<template>
  <div id="roadSideParkMain">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>停车场</el-breadcrumb-item>
          <el-breadcrumb-item>路侧场库设置</el-breadcrumb-item>
          <el-breadcrumb-item>停车场管理</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row>
      <el-form :inline="true"
               class="demo-form-inline">
        <el-row>
          <el-col :span="22">
            <el-form-item label="客户名称::"
                          style="margin-bottom: 10px;">
              <el-select v-model="selCustID"
                         filterable
                         clearable
                         placeholder="所有客户">
                <el-option v-for="item in choiceCusts"
                           :key="item.fCustID"
                           :label="item.unionName"
                           :value="item.fCustID">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="场库名称::">
              <el-input placeholder="请输入场库名称"
                        v-model="queryParkName"
                        class="input-with-select">
              </el-input>
            </el-form-item>
            <el-form-item label="场库编号::">
              <el-input placeholder="请输入场库编号"
                        v-model="queryParkNo"
                        class="input-with-select">
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary"
                         icon="el-icon-search"
                         size="small"
                         @click="bindQuery">查询</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="2"
                  class="searchRowAdd">
            <el-button type="primary"
                       size="small"
                       @click="addRoadSidePark"
                       v-if="is_edit">新增场库</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-row>
    <el-row>
      <el-table :data="parkList"
                border
                highlight-current-row
                style="width: 100%"
                v-loading="loading"
                :height="tableHeight"
                ref="singleTable">
        <el-table-column type="index"
                         width="50"
                         label="序号"
                         align="right"
                         :index="indexMethod">
        </el-table-column>
        <el-table-column prop="fCustNo"
                         width="80"
                         label="客户编号">
        </el-table-column>
        <el-table-column prop="fCustName"
                         width="160"
                         label="客户名称">
        </el-table-column>
        <el-table-column prop="fParkNo"
                         width="80"
                         label="场库编号">
        </el-table-column>
        <el-table-column prop="fParkName"
                         width="160"
                         label="场库名称">
        </el-table-column>
        <el-table-column prop="fParkTypeName"
                         width="100"
                         label="场库类型">
        </el-table-column>
        <el-table-column prop="fParkCount"
                         width="80"
                         align="right"
                         label="车位数量">
        </el-table-column>
        <el-table-column prop="fResCount"
                         width="80"
                         align="right"
                         label="保留数量">
        </el-table-column>
        <el-table-column prop="fAddress"
                         label="场库地址">
        </el-table-column>
        <el-table-column fixed="right"
                         align="center"
                         label="操作"
                         width="300">
          <template slot-scope="scope">
            <el-button @click="viewRoadSidePark(scope.row)"
                       type="success"
                       size="mini">查看</el-button>
            <el-button size="mini"
                       type="warning"
                       v-if="is_edit"
                       @click="editParkClient(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini"
                       type="danger"
                       v-if="is_del"
                       @click="deleteParkClient(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination background
                         @size-change="handleSizeChange"
                         :current-page.sync="pageIndex"
                         @current-change="handlePage"
                         :page-size="pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="total"
                         v-if="total>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <div class="roadSideParkEditOrDetail">
      <el-dialog :title="detailTitle"
                 :visible.sync="editOrDetailVisible"
                 v-dialogDrag
                 top="7vh"
                 left="0vh"
                 width="60%">
        <el-tabs v-model="editOrDetail"
                 tab-position="left"
                 type="card"
                 @tab-click="tab_click">
          <el-tab-pane label="基本信息"
                       name="editBaseInfo">
            <el-form :model="curRowInfo"
                     label-width="100px"
                     :inline="true"
                     style="margin-top:10px;">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="客户名称::">
                    <el-select v-model="curRowInfo.fCustID"
                               filterable
                               placeholder="请选择客户"
                               :disabled="!curRowInfo.isEdit"
                               style="width:250px;"
                               @change="custChange">
                      <el-option v-for="item in choiceCusts"
                                 :key="item.fCustID"
                                 :label="item.unionName"
                                 :value="item.fCustID">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="场库编号::">
                    <el-input v-model="curRowInfo.fParkNo"
                              style="width:250px;"
                              :disabled="!curRowInfo.isEdit"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="场库名称::">
                    <el-input v-model="curRowInfo.fParkName"
                              style="width:250px;"
                              :disabled="!curRowInfo.isEdit"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="联系人::">
                    <el-input v-model="curRowInfo.fLinkman"
                              style="width:250px;"
                              :disabled="!curRowInfo.isEdit"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="联系电话::">
                    <el-input v-model="curRowInfo.fLinkPhone"
                              style="width:250px;"
                              :disabled="!curRowInfo.isEdit"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="车位数量::">
                    <el-input v-model="curRowInfo.fParkCount"
                              style="width:250px;"
                              :disabled="!curRowInfo.isEdit"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="保留车位数量::">
                    <el-input v-model="curRowInfo.fResCount"
                              style="width:250px;"
                              :disabled="!curRowInfo.isEdit"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="场库地址::">
                    <el-input v-model="curRowInfo.fAddress"
                              :disabled="!curRowInfo.isEdit"
                              style="width:773px"
                              @keyup.native="address_keyup"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label=" "
                                style="height:300px;">
                    <div class="search_list"
                         v-if="map_search_list.length > 0">
                      <el-row :key="index"
                              v-for="(item, index) in map_search_list"
                              @click.native="map_search_change(item, index)">
                        <el-col class="t"
                                :span="24"
                                v-html="item.title"></el-col>
                        <el-col class="a"
                                :span="24"
                                v-html="item.address"></el-col>
                      </el-row>
                    </div>
                    <div id="parkBaiduMap"
                         :style="{ width: (map_search_list.length > 0 ?'473px':'773px'), height:'300px' }"></div>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="场库设置"
                       name="editParkInfo">
            <el-form :model="parkSetting"
                     :inline="true"
                     label-width="200px"
                     style="margin-top:10px;">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="临时车费率组::">
                    <el-select v-model="parkSetting.p10010"
                               placeholder="请选择"
                               style="width:250px;"
                               :disabled="!curRowInfo.isEdit">
                      <el-option v-for="item in rateSelectList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="蓝牌车费率组::">
                    <el-select v-model="parkSetting.p10020"
                               placeholder="请选择"
                               style="width:250px;"
                               :disabled="!curRowInfo.isEdit">
                      <el-option v-for="item in rateSelectList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="绿牌车费率组::">
                    <el-select v-model="parkSetting.p10021"
                               placeholder="请选择"
                               style="width:250px;"
                               :disabled="!curRowInfo.isEdit">
                      <el-option v-for="item in rateSelectList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="黄牌车费率组::">
                    <el-select v-model="parkSetting.p10022"
                               placeholder="请选择"
                               style="width:250px;"
                               :disabled="!curRowInfo.isEdit">
                      <el-option v-for="item in rateSelectList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="非本场库月卡车费率组::">
                    <el-select v-model="parkSetting.p10024"
                               placeholder="请选择"
                               style="width:250px"
                               :disabled="!curRowInfo.isEdit">
                      <el-option v-for="item in rateSelectList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="无入场记录费率组::">
                    <el-select v-model="parkSetting.p10023"
                               placeholder="请选择"
                               style="width:250px;"
                               :disabled="!curRowInfo.isEdit">
                      <el-option v-for="item in rateSelectList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="车辆图片保存时间::">
                    <el-select v-model="parkSetting.p10170"
                               placeholder="请选择"
                               style="width:250px;"
                               :disabled="!curRowInfo.isEdit">
                      <el-option v-for="item in parkPicSaveList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="营业时间::">
                    <el-select v-model="parkSetting.p10320"
                               :disabled="!curRowInfo.isEdit"
                               style="width:100px"
                               filterable>
                      <el-option v-for="item in businessTimeList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                    <span style="width:20px">-</span>
                    <el-select v-model="parkSetting.p10330"
                               :disabled="!curRowInfo.isEdit"
                               style="width:100px;"
                               filterable>
                      <el-option v-for="item in businessTimeList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="免费停车时长(分钟)::">
                    <el-input v-model="parkSetting.p10030"
                              style="width:250px;"
                              :disabled="!curRowInfo.isEdit"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="预支付免费出场时间(分钟)::">
                    <el-input v-model="parkSetting.p10180"
                              style="width:250px;"
                              :disabled="!curRowInfo.isEdit"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="自动删除超过::">
                    <el-select v-model="parkSetting.p10350"
                               placeholder="请选择"
                               style="width:100px"
                               :disabled="!curRowInfo.isEdit">
                      <el-option v-for="item in autoDelDataList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                    <span>在场数据</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-tab-pane>
          <el-tab-pane>
            <span slot="label"><i class="el-icon-check"
                 v-if="(RJInvoiceObject.p99160=='1')"></i> 容津发票</span>
            <fieldset>
              <legend style="padding-top: 10px">
                容津电子发票
              </legend>
              <el-form :model="RJInvoiceObject"
                       :inline="true"
                       label-width="120px">
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="参数::">
                      <el-radio-group v-model="RJInvoiceObject.IsDefault"
                                      @change="setParams($event,1)"
                                      :disabled="!curRowInfo.isEdit">
                        <el-radio :label="true">商秸参数</el-radio>
                        <el-radio :label="false">无参数</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="APPID::">
                      <el-input v-model="RJInvoiceObject.p99110"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="KEY::">
                      <el-input v-model="RJInvoiceObject.p99120"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="开票点参数::">
                      <el-input v-model="RJInvoiceObject.p99130"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="上传数据地址::">
                      <el-input v-model="RJInvoiceObject.p99140"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="开票链接::">
                      <el-input v-model="RJInvoiceObject.p99150"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="启用状态::">
                      <el-radio-group v-model="RJInvoiceObject.p99160"
                                      @change="changeInvoiceEnable($event,1)"
                                      :disabled="!curRowInfo.isEdit">
                        <el-radio label="0">禁用</el-radio>
                        <el-radio label="1">启用</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
          </el-tab-pane>
          <el-tab-pane name="EInvoiceObject">
            <span slot="label"><i class="el-icon-check"
                 v-if="(EInvoiceObject.p99299=='1')"></i> E开票</span>
            <fieldset>
              <legend style="padding-top: 10px">
                E开票
              </legend>
              <el-form :model="EInvoiceObject"
                       :inline="true"
                       label-width="120px">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="开票方公司名称::">
                      <el-input v-model="EInvoiceObject.p99210"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="开票方税号::">
                      <el-input v-model="EInvoiceObject.p99220"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="开票方机号::">
                      <el-input v-model="EInvoiceObject.p99230"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="公司电话::">
                      <el-input v-model="EInvoiceObject.p99250"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="公司地址::">
                      <el-input v-model="EInvoiceObject.p99240"
                                :disabled="!curRowInfo.isEdit"
                                style="width:500px"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="开票联系人::">
                      <el-input v-model="EInvoiceObject.p99260"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="发票回传路径::">
                      <el-input v-model="EInvoiceObject.p99270"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="撤销开票命令::">
                      <el-input v-model="EInvoiceObject.p99280"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="商品税收编码::">
                      <el-input v-model="EInvoiceObject.p99290"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="启用状态::">
                      <el-radio-group v-model="EInvoiceObject.p99299"
                                      @change="changeInvoiceEnable($event,2)"
                                      :disabled="!curRowInfo.isEdit">
                        <el-radio label="0">禁用</el-radio>
                        <el-radio label="1">启用</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
          </el-tab-pane>
            <el-tab-pane name="HTInvoiceObject">
                <span slot="label"><i class="el-icon-check"
                         v-if="(HTInvoiceObject.p99808=='1')"></i>航天发票</span>
                    <el-tabs type="card" class="child_card" >
                     <el-tab-pane label="诺诺电子发票企业端同步发票通用版(2.2.7)" >
                       <fieldset>
                        <el-form :model="HTInvoiceObject"
                               :inline="true"
                               label-width="120px">
                        <el-row>
                          <el-col :span="12">
                            <el-form-item label="身份认证::">
                              <el-input v-model="HTInvoiceObject.p99801"
                                        :disabled="!curRowInfo.isEdit"
                                        class="myParkInput"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="开票员::">
                              <el-input v-model="HTInvoiceObject.p99803"
                                        :disabled="!curRowInfo.isEdit"
                                        class="myParkInput"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="12">
                            <el-form-item label="销方税号::">
                              <el-input v-model="HTInvoiceObject.p99804"
                                        :disabled="!curRowInfo.isEdit"
                                        class="myParkInput"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="税收分类编码::">
                              <el-input v-model="HTInvoiceObject.p99806"
                                        :disabled="!curRowInfo.isEdit"
                                        class="myParkInput"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="12">
                            <el-form-item label="税率(%)::">
                              <el-input v-model="HTInvoiceObject.p99805"
                                        :disabled="!curRowInfo.isEdit"
                                        class="myParkInput"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="开票天数::">
                              <el-input v-model="HTInvoiceObject.p99807"
                                        :disabled="!curRowInfo.isEdit"
                                        class="myParkInput"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="12">
                             <el-form-item label="开票请求链接::">
                              <el-input v-model="HTInvoiceObject.p99802"
                                        :disabled="!curRowInfo.isEdit"
                                        class="myParkInput"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12">
                            <el-form-item label="启用状态::">
                              <el-radio-group v-model="HTInvoiceObject.p99808"
                                              @change="changeInvoiceEnable($event,3)"
                                              :disabled="!curRowInfo.isEdit">
                                <el-radio label="0">禁用</el-radio>
                                <el-radio label="1">启用</el-radio>
                              </el-radio-group>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-form>
                    </fieldset>
                  </el-tab-pane>
                 </el-tabs>
            </el-tab-pane>
          <el-tab-pane name="unionPayInfo">
            <span slot="label"><i class="el-icon-check"
                 v-if="(unionPayInfoObject.p71060=='1'||unionPayInfoObject.p71190=='1')"></i> 银联支付</span>
            <fieldset>
              <legend style="padding-top: 10px">
                注册信息
              </legend>
              <el-form label-width="120px"
                       :inline="true">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="注册方式::">
                      <el-select v-model="unionPayReg.fRegType"
                                 placeholder="请选择方式"
                                 :disabled="!curRowInfo.isEdit"
                                 class="myParkInput">
                        <el-option v-for="item in regTypeList"
                                   :key="item.value"
                                   :label="item.text"
                                   :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="注册用户::">
                      <el-input v-model="unionPayReg.fLinkman"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="联系电话::">
                      <el-input v-model="unionPayReg.fLinkPhone"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="有效起始时间::">
                      <el-date-picker v-model="unionPayReg.fStartDate"
                                      type="date"
                                      :disabled="!curRowInfo.isEdit"
                                      placeholder="选择有效起始时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="有效结束时间::">
                      <el-date-picker v-model="unionPayReg.fEndDate"
                                      :disabled="!curRowInfo.isEdit"
                                      type="date"
                                      placeholder="选择有效结束时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="备注::">
                      <el-input v-model="unionPayReg.fRemark"
                                style="width:500px"
                                :disabled="!curRowInfo.isEdit"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
            <fieldset>
              <legend>银联支付BtoC设置</legend>
              <el-form :inline="true"
                       label-width="120px">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="POS通商户号::">
                      <el-input v-model="unionPayInfoObject.p71010"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="POS终端号::">
                      <el-input v-model="unionPayInfoObject.p71020"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="APPID::">
                      <el-input v-model="unionPayInfoObject.p71030"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="APPKEY::">
                      <el-input v-model="unionPayInfoObject.p71040"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="支付链接::">
                      <el-input v-model="unionPayInfoObject.p71050"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="启用状态::">
                      <el-radio-group v-model="unionPayInfoObject.p71060"
                                      :disabled="!curRowInfo.isEdit"
                                      @change="changeEnable($event,1,'b2c')">
                        <el-radio label="0">禁用</el-radio>
                        <el-radio label="1">启用</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
            <fieldset>
              <legend>银联支付CtoB设置</legend>
              <el-form :inline="true"
                       label-width="120px">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="商户号::">
                      <el-input v-model="unionPayInfoObject.p71110"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="终端编号::">
                      <el-input v-model="unionPayInfoObject.p71120"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="业务类型::">
                      <el-input v-model="unionPayInfoObject.p71130"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="消息来源::">
                      <el-input v-model="unionPayInfoObject.p71140"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="消息来源ID::">
                      <el-input v-model="unionPayInfoObject.p71150"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="Key::">
                      <el-input v-model="unionPayInfoObject.p71160"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="支付链接::">
                      <el-input v-model="unionPayInfoObject.p71210"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="启用状态::">
                      <el-radio-group v-model="unionPayInfoObject.p71190"
                                      :disabled="!curRowInfo.isEdit"
                                      @change="changeEnable($event,1,'c2b')">
                        <el-radio label="0">禁用</el-radio>
                        <el-radio label="1">启用</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
            <fieldset>
              <legend>银联ERP积分抵扣设置</legend>
              <el-form :inline="true"
                       label-width="120px">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="SignKey::">
                      <el-input v-model="unionPayInfoObject.p71991"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="AppKey::">
                      <el-input v-model="unionPayInfoObject.p71992"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="积分抵扣链接::">
                      <el-input v-model="unionPayInfoObject.p71990"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="MethodVer::">
                      <el-input v-model="unionPayInfoObject.p71993"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
          </el-tab-pane>
          <el-tab-pane name="wechatSerInfo">
            <span slot="label"><i class="el-icon-check"
                 v-if="wechatSerInfoObject.p72070=='1'"></i> 微信商户号</span>
            <fieldset>
              <legend style="padding-top: 10px">
                注册信息
              </legend>
              <el-form :inline="true"
                       label-width="120px">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="注册方式::">
                      <el-select v-model="weChatSvrPayReg.fRegType"
                                 placeholder="请选择方式"
                                 :disabled="!curRowInfo.isEdit"
                                 class="myParkInput">
                        <el-option v-for="item in regTypeList"
                                   :key="item.value"
                                   :label="item.text"
                                   :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="注册用户::">
                      <el-input v-model="weChatSvrPayReg.fLinkman"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="联系电话::">
                      <el-input v-model="weChatSvrPayReg.fLinkPhone"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="有效起始时间::">
                      <el-date-picker v-model="weChatSvrPayReg.fStartDate"
                                      type="date"
                                      :disabled="!curRowInfo.isEdit"
                                      placeholder="选择有效起始时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="有效结束时间::">
                      <el-date-picker v-model="weChatSvrPayReg.fEndDate"
                                      type="date"
                                      :disabled="!curRowInfo.isEdit"
                                      placeholder="选择有效结束时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="备注::">
                      <el-input v-model="weChatSvrPayReg.fRemark"
                                style="width:500px"
                                :disabled="!curRowInfo.isEdit"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
            <fieldset>
              <legend>服务商户</legend>
              <el-form :model="wechatSerInfoObject"
                       :inline="true"
                       label-width="120px">
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="参数::">
                      <el-radio-group v-model="wechatSerInfoObject.IsDefault"
                                      @change="setParams($event,2)"
                                      :disabled="!curRowInfo.isEdit">
                        <el-radio :label="true">商秸参数</el-radio>
                        <el-radio :label="false">无参数</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="公众账号ID::">
                      <el-input v-model="wechatSerInfoObject.p72010"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="商户号::">
                      <el-input v-model="wechatSerInfoObject.p72020"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="子商户公众号ID::">
                      <el-input v-model="wechatSerInfoObject.p72030"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="子商户号::">
                      <el-input v-model="wechatSerInfoObject.p72040"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="AppKey::">
                      <el-input v-model="wechatSerInfoObject.p72050"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="密钥::">
                      <el-input v-model="wechatSerInfoObject.p72060"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="进场通知模板::">
                      <el-input v-model="wechatSerInfoObject.p72100"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="出场通知模板::">
                      <el-input v-model="wechatSerInfoObject.p72110"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="支付链接::">
                      <el-input v-model="wechatSerInfoObject.p72080"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="启用状态::">
                      <el-radio-group v-model="wechatSerInfoObject.p72070"
                                      :disabled="!curRowInfo.isEdit"
                                      @change="changeEnable($event,2)">
                        <el-radio label="0">禁用</el-radio>
                        <el-radio label="1">启用</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
          </el-tab-pane>
          <el-tab-pane name="wechatComInfo">
            <span slot="label"><i class="el-icon-check"
                 v-if="wechatComInfoObject.p73050=='1'"></i> 微信公众号</span>
            <fieldset>
              <legend style="padding-top: 10px">
                注册信息
              </legend>
              <el-form label-width="120px"
                       :inline="true">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="注册方式::">
                      <el-select v-model="weChatComPayReg.fRegType"
                                 placeholder="请选择方式"
                                 :disabled="!curRowInfo.isEdit"
                                 class="myParkInput">
                        <el-option v-for="item in regTypeList"
                                   :key="item.value"
                                   :label="item.text"
                                   :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="注册用户::">
                      <el-input v-model="weChatComPayReg.fLinkman"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="联系电话::">
                      <el-input v-model="weChatComPayReg.fLinkPhone"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="有效起始时间::">
                      <el-date-picker v-model="weChatComPayReg.fStartDate"
                                      type="date"
                                      :disabled="!curRowInfo.isEdit"
                                      placeholder="选择有效起始时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="有效结束时间::">
                      <el-date-picker v-model="weChatComPayReg.fEndDate"
                                      type="date"
                                      :disabled="!curRowInfo.isEdit"
                                      placeholder="选择有效结束时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="备注::">
                      <el-input v-model="weChatComPayReg.fRemark"
                                style="width:500px"
                                :disabled="!curRowInfo.isEdit"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
            <fieldset>
              <legend>普通商户</legend>
              <el-form :model="wechatComInfoObject"
                       :inline="true"
                       label-width="120px">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="公众账号ID::">
                      <el-input v-model="wechatComInfoObject.p73010"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="商户号::">
                      <el-input v-model="wechatComInfoObject.p73020"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="AppKey::">
                      <el-input v-model="wechatComInfoObject.p73030"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="密钥::">
                      <el-input v-model="wechatComInfoObject.p73040"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="进场通知模板::">
                      <el-input v-model="wechatComInfoObject.p73080"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="出场通知模板::">
                      <el-input v-model="wechatComInfoObject.p73090"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="支付链接::">
                      <el-input v-model="wechatComInfoObject.p73070"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="启用状态::">
                      <el-radio-group v-model="wechatComInfoObject.p73050"
                                      :disabled="!curRowInfo.isEdit"
                                      @change="changeEnable($event,3)">
                        <el-radio label="0">禁用</el-radio>
                        <el-radio label="1">启用</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
          </el-tab-pane>
          <el-tab-pane name="APPLETPay">
            <span slot="label"><i class="el-icon-check"
                 v-if="(AppletInfoObject.p73165=='1')"></i>微信小程序</span>
            <fieldset>
              <legend style="padding-top: 10px">
                注册信息
              </legend>
              <el-form :inline="true"
                       label-width="120px">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="注册方式::">
                      <el-select v-model="AppletPayReg.fRegType"
                                 placeholder="请选择方式"
                                 :disabled="!curRowInfo.isEdit"
                                 class="myParkInput">
                        <el-option v-for="item in regTypeList"
                                   :key="item.value"
                                   :label="item.text"
                                   :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="注册用户::">
                      <el-input v-model="AppletPayReg.fLinkman"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="联系电话::">
                      <el-input v-model="AppletPayReg.fLinkPhone"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="有效起始时间::">
                      <el-date-picker v-model="AppletPayReg.fStartDate"
                                      type="date"
                                      :disabled="!curRowInfo.isEdit"
                                      placeholder="选择有效起始时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="有效结束时间::">
                      <el-date-picker v-model="AppletPayReg.fEndDate"
                                      type="date"
                                      :disabled="!curRowInfo.isEdit"
                                      placeholder="选择有效结束时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="备注::">
                      <el-input v-model="AppletPayReg.fRemark"
                                style="width:500px"
                                :disabled="!curRowInfo.isEdit"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
            <fieldset>
              <legend>微信小程序
                <el-link v-if="is_admin"
                         href="https://wxpap.shangjieiot.com/#/login?redirect=%2Fdashboard"
                         type="danger"
                         target="_blank">后台管理</el-link>
              </legend>
              <el-form :model="AppletInfoObject"
                       :inline="true"
                       label-width="120px">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="悟能APPID::">
                      <el-input v-model="AppletInfoObject.p73110"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="悟能APPKEY::">
                      <el-input v-model="AppletInfoObject.p73130"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="商户号::">
                      <el-input v-model="AppletInfoObject.p73115"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="发票连接::">
                      <el-input v-model="AppletInfoObject.p73150"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="悟能接口地址::">
                      <el-input v-model="AppletInfoObject.p73151"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="发送模板消息::">
                      <el-select v-model="AppletInfoObject.p73152"
                                 placeholder="请选择"
                                 :disabled="!curRowInfo.isEdit"
                                 class="myParkInput">
                        <el-option label="否"
                                   value="0"></el-option>
                        <el-option label="是"
                                   value="1"></el-option>
                      </el-select>
                      <!-- <el-radio-group v-model="AppletInfoObject.p73152"
                                        :disabled="!isEdit">
                          <el-radio label="0">否</el-radio>
                          <el-radio label="1">是</el-radio>
                        </el-radio-group> -->
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="停车场ID::">
                      <el-input v-model="AppletInfoObject.p73153"
                                :disabled="true"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="启用状态::">
                      <el-radio-group v-model="AppletInfoObject.p73165"
                                      @change="changeEnable($event,8)"
                                      :disabled="!curRowInfo.isEdit">
                        <el-radio label="0">禁用</el-radio>
                        <el-radio label="1">启用</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
          </el-tab-pane>
          <el-tab-pane name="alipayInfo">
            <span slot="label"><i class="el-icon-check"
                 v-if="alipayInfoObject.p74060=='1'"></i> 支付宝</span>
            <fieldset>
              <legend style="padding-top: 10px">
                注册信息
              </legend>
              <el-form :inline="true"
                       label-width="120px">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="注册方式::">
                      <el-select v-model="aliPayReg.fRegType"
                                 placeholder="请选择方式"
                                 :disabled="!curRowInfo.isEdit"
                                 class="myParkInput">
                        <el-option v-for="item in regTypeList"
                                   :key="item.value"
                                   :label="item.text"
                                   :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="注册用户::">
                      <el-input v-model="aliPayReg.fLinkman"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="联系电话::">
                      <el-input v-model="aliPayReg.fLinkPhone"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="有效起始时间::">
                      <el-date-picker v-model="aliPayReg.fStartDate"
                                      type="date"
                                      :disabled="!curRowInfo.isEdit"
                                      placeholder="选择有效起始时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="有效结束时间::">
                      <el-date-picker v-model="aliPayReg.fEndDate"
                                      type="date"
                                      :disabled="!curRowInfo.isEdit"
                                      placeholder="选择有效结束时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="备注::">
                      <el-input v-model="aliPayReg.fRemark"
                                style="width:500px"
                                :disabled="!curRowInfo.isEdit"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
            <fieldset>
              <legend>支付宝支付</legend>
              <el-form :model="alipayInfoObject"
                       :inline="true"
                       label-width="120px">
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="参数::">
                      <el-radio-group v-model="alipayInfoObject.IsDefault"
                                      @change="setParams($event,3)"
                                      :disabled="!curRowInfo.isEdit">
                        <el-radio :label="true">商秸参数</el-radio>
                        <el-radio :label="false">无参数</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="支付宝AppID::">
                      <el-input v-model="alipayInfoObject.p74010"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row class="fRemark_row">
                  <el-col :span="24">
                    <el-form-item label="商户私钥::">
                      <!-- <el-input v-model="alipayInfoObject.p74030"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input> -->
                      <el-input type="textarea"
                                v-model="alipayInfoObject.p74030"
                                :disabled="!curRowInfo.isEdit"
                                class="parkTextArea"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row class="fRemark_row">
                  <el-col :span="24">
                    <el-form-item label="支付宝公钥::">
                      <!-- <el-input v-model="alipayInfoObject.p74020"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input> -->
                      <el-input type="textarea"
                                v-model="alipayInfoObject.p74020"
                                :disabled="!curRowInfo.isEdit"
                                class="parkTextArea"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="服务商PID::">
                      <el-input v-model="alipayInfoObject.p74001"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="授权token::">
                      <el-input v-model="alipayInfoObject.p74002"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="支付链接::">
                      <el-input v-model="alipayInfoObject.p74040"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="支付宝场库ID::">
                      <el-input v-model="alipayInfoObject.p74003"
                                :disabled="true"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="启用状态::">
                      <el-radio-group v-model="alipayInfoObject.p74060"
                                      :disabled="!curRowInfo.isEdit"
                                      @change="changeEnable($event,4)">
                        <el-radio label="0">禁用</el-radio>
                        <el-radio label="1">启用</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
          </el-tab-pane>
          <el-tab-pane name="BOCMWxPay">
            <span slot="label"><i class="el-icon-check"
                 v-if="(BOCMWxInfoObject.p75080=='1')"></i> 交行银联</span>
            <fieldset>
              <legend style="padding-top: 10px">
                注册信息
              </legend>
              <el-form :inline="true"
                       label-width="120px">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="注册方式::">
                      <el-select v-model="BOCMWxPayReg.fRegType"
                                 placeholder="请选择方式"
                                 :disabled="!curRowInfo.isEdit"
                                 class="myParkInput">
                        <el-option v-for="item in regTypeList"
                                   :key="item.value"
                                   :label="item.text"
                                   :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="注册用户::">
                      <el-input v-model="BOCMWxPayReg.fLinkman"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="联系电话::">
                      <el-input v-model="BOCMWxPayReg.fLinkPhone"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="有效起始时间::">
                      <el-date-picker v-model="BOCMWxPayReg.fStartDate"
                                      type="date"
                                      :disabled="!curRowInfo.isEdit"
                                      placeholder="选择有效起始时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="有效结束时间::">
                      <el-date-picker v-model="BOCMWxPayReg.fEndDate"
                                      type="date"
                                      :disabled="!curRowInfo.isEdit"
                                      placeholder="选择有效结束时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="备注::">
                      <el-input v-model="BOCMWxPayReg.fRemark"
                                style="width:500px"
                                :disabled="!curRowInfo.isEdit"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
            <fieldset>
              <legend>基础参数</legend>
              <el-form :model="BOCMWxInfoObject"
                       :inline="true"
                       label-width="120px">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="商户号::">
                      <el-input v-model="BOCMWxInfoObject.p75020"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="AppKey::">
                      <el-input v-model="BOCMWxInfoObject.p75030"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="启用状态::">
                      <el-radio-group v-model="BOCMWxInfoObject.p75080"
                                      :disabled="!curRowInfo.isEdit"
                                      @change="changeEnable($event,5)">
                        <el-radio label="0">禁用</el-radio>
                        <el-radio label="1">启用</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
            <fieldset>
              <legend>微信</legend>
              <el-form :model="BOCMWxInfoObject"
                       :inline="true"
                       label-width="120px">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="公众账号ID::">
                      <el-input v-model="BOCMWxInfoObject.p75010"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="密钥::">
                      <el-input v-model="BOCMWxInfoObject.p75040"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="进场通知模板::">
                      <el-input v-model="BOCMWxInfoObject.p75050"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="出场通知模板::">
                      <el-input v-model="BOCMWxInfoObject.p75060"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="支付链接::">
                      <el-input v-model="BOCMWxInfoObject.p75070"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
            <fieldset>
              <legend>支付宝</legend>
              <el-form :model="BOCMWxInfoObject"
                       :inline="true"
                       label-width="120px">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="支付宝APPID::">
                      <el-input v-model="BOCMWxInfoObject.p75090"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row class="fRemark_row">
                  <el-col :span="24">
                    <el-form-item label="私钥::">
                      <el-input type="textarea"
                                v-model="BOCMWxInfoObject.p75100"
                                :disabled="!curRowInfo.isEdit"
                                class="parkTextArea"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row class="fRemark_row">
                  <el-col :span="24">
                    <el-form-item label="公钥::">
                      <el-input type="textarea"
                                v-model="BOCMWxInfoObject.p75110"
                                :disabled="!curRowInfo.isEdit"
                                class="parkTextArea"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
          </el-tab-pane>
          <el-tab-pane name="ICBCPay">
            <span slot="label"><i class="el-icon-check"
                 v-if="(ICBCInfoObject.p76090=='1'||ICBCInfoObject.p76091=='1')"></i> 工行支付</span>
            <fieldset>
              <legend style="padding-top: 10px">
                注册信息
              </legend>
              <el-form :inline="true"
                       label-width="120px">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="注册方式::">
                      <el-select v-model="ICBCPayReg.fRegType"
                                 placeholder="请选择方式"
                                 :disabled="!curRowInfo.isEdit"
                                 class="myParkInput">
                        <el-option v-for="item in regTypeList"
                                   :key="item.value"
                                   :label="item.text"
                                   :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="注册用户::">
                      <el-input v-model="ICBCPayReg.fLinkman"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="联系电话::">
                      <el-input v-model="ICBCPayReg.fLinkPhone"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="有效起始时间::">
                      <el-date-picker v-model="ICBCPayReg.fStartDate"
                                      type="date"
                                      :disabled="!curRowInfo.isEdit"
                                      placeholder="选择有效起始时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="有效结束时间::">
                      <el-date-picker v-model="ICBCPayReg.fEndDate"
                                      type="date"
                                      :disabled="!curRowInfo.isEdit"
                                      placeholder="选择有效结束时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="备注::">
                      <el-input v-model="ICBCPayReg.fRemark"
                                style="width:500px"
                                :disabled="!curRowInfo.isEdit"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
            <fieldset>
              <legend>工行支付</legend>
              <el-form :model="ICBCInfoObject"
                       :inline="true"
                       label-width="120px">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="APPID::">
                      <el-input v-model="ICBCInfoObject.p76010"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row class="fRemark_row">
                  <el-col :span="24">
                    <el-form-item label="私钥::">
                      <el-input type="textarea"
                                v-model="ICBCInfoObject.p76020"
                                :disabled="!curRowInfo.isEdit"
                                class="parkTextArea"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row class="fRemark_row">
                  <el-col :span="24">
                    <el-form-item label="公钥::">
                      <el-input type="textarea"
                                v-model="ICBCInfoObject.p76030"
                                :disabled="!curRowInfo.isEdit"
                                class="parkTextArea"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="C2B版本::">
                      <el-select v-model="ICBCInfoObject.p76094"
                                 :disabled="!curRowInfo.isEdit"
                                 class="myParkInput"
                                 placeholder="请选择版本">
                        <el-option v-for="item in c2bUrlList"
                                   :key="item.value"
                                   :label="item.label"
                                   :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="B2C版本::">
                      <el-select v-model="ICBCInfoObject.p76092"
                                 :disabled="!curRowInfo.isEdit"
                                 class="myParkInput"
                                 placeholder="请选择版本">
                        <el-option v-for="item in b2cUrlList"
                                   :key="item.value"
                                   :label="item.label"
                                   :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="无感支付版本::">
                      <el-select v-model="ICBCInfoObject.p76093"
                                 :disabled="!curRowInfo.isEdit"
                                 class="myParkInput"
                                 placeholder="请选择版本">
                        <el-option v-for="item in platePayUrlList"
                                   :key="item.value"
                                   :label="item.label"
                                   :value="item.value">
                        </el-option>
                      </el-select>
                      <!-- <el-input v-model="ICBCInfoObject.p76093"
                                  :disabled="!isEdit"
                                  class="myParkInput"></el-input> -->
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="无感签约版本::">
                      <el-select v-model="ICBCInfoObject.p76096"
                                 :disabled="!curRowInfo.isEdit"
                                 class="myParkInput"
                                 placeholder="请选择版本">
                        <el-option v-for="item in plateUrlList"
                                   :key="item.value"
                                   :label="item.label"
                                   :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="商户档案编号::">
                      <el-input v-model="ICBCInfoObject.p76040"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="e生活号::">
                      <el-input v-model="ICBCInfoObject.p76050"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="商户类型::">
                      <el-select v-model="ICBCInfoObject.p76080"
                                 :disabled="!curRowInfo.isEdit"
                                 placeholder="请选择商户类型"
                                 class="myParkInput">
                        <el-option v-for="item in merchantType"
                                   :key="item.value"
                                   :label="item.label"
                                   :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="商户名称::">
                      <el-input v-model="ICBCInfoObject.p76060"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="商户入账账号::">
                      <el-input v-model="ICBCInfoObject.p76070"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="无感绑定AESKEY::">
                      <el-input v-model="ICBCInfoObject.p76095"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="启用状态::">
                      <el-radio-group v-model="ICBCInfoObject.p76090"
                                      :disabled="!curRowInfo.isEdit"
                                      @change="changeEnable($event,6)">
                        <el-radio label="0">禁用</el-radio>
                        <el-radio label="1">启用</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="无感启用状态::">
                      <el-radio-group v-model="ICBCInfoObject.p76091"
                                      :disabled="!curRowInfo.isEdit">
                        <el-radio label="0">禁用</el-radio>
                        <el-radio label="1">启用</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
          </el-tab-pane>
          <el-tab-pane name="CGBCPay">
            <span slot="label"><i class="el-icon-check"
                 v-if="(CGBInfoObject.p77050=='1')"></i> 广发支付</span>
            <fieldset>
              <legend style="padding-top: 10px">
                注册信息
              </legend>
              <el-form :inline="true"
                       label-width="120px">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="注册方式::">
                      <el-select v-model="CGBPayReg.fRegType"
                                 placeholder="请选择方式"
                                 :disabled="!curRowInfo.isEdit"
                                 class="myParkInput">
                        <el-option v-for="item in regTypeList"
                                   :key="item.value"
                                   :label="item.text"
                                   :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="注册用户::">
                      <el-input v-model="CGBPayReg.fLinkman"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="联系电话::">
                      <el-input v-model="CGBPayReg.fLinkPhone"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="有效起始时间::">
                      <el-date-picker v-model="CGBPayReg.fStartDate"
                                      type="date"
                                      :disabled="!curRowInfo.isEdit"
                                      placeholder="选择有效起始时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="有效结束时间::">
                      <el-date-picker v-model="CGBPayReg.fEndDate"
                                      type="date"
                                      :disabled="!curRowInfo.isEdit"
                                      placeholder="选择有效结束时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="备注::">
                      <el-input v-model="CGBPayReg.fRemark"
                                style="width:500px"
                                :disabled="!curRowInfo.isEdit"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
            <fieldset>
              <legend>广发支付</legend>
              <el-form :model="CGBInfoObject"
                       :inline="true"
                       label-width="120px">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="商户号::">
                      <el-input v-model="CGBInfoObject.p77010"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row class="fRemark_row">
                  <el-col :span="24">
                    <el-form-item label="私钥::">
                      <el-input type="textarea"
                                v-model="CGBInfoObject.p77020"
                                :disabled="!curRowInfo.isEdit"
                                class="parkTextArea"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row class="fRemark_row">
                  <el-col :span="24">
                    <el-form-item label="公钥::">
                      <el-input type="textarea"
                                v-model="CGBInfoObject.p77030"
                                :disabled="!curRowInfo.isEdit"
                                class="parkTextArea"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="支付链接::">
                      <el-input v-model="CGBInfoObject.p77040"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="启用状态::">
                      <el-radio-group v-model="CGBInfoObject.p77050"
                                      :disabled="!curRowInfo.isEdit"
                                      @change="changeEnable($event,7)">
                        <el-radio label="0">禁用</el-radio>
                        <el-radio label="1">启用</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
          </el-tab-pane>
          <el-tab-pane name="CCBPay">
            <span slot="label"><i class="el-icon-check"
                 v-if="(CCBInfoObject.p79070=='1'||CCBInfoObject.p79080=='1')"></i> 建行支付</span>
            <fieldset>
              <legend style="padding-top: 10px">
                注册信息
              </legend>
              <el-form :inline="true"
                       label-width="120px">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="注册方式::">
                      <el-select v-model="CCBPayReg.fRegType"
                                 placeholder="请选择方式"
                                 :disabled="!curRowInfo.isEdit"
                                 class="myParkInput">
                        <el-option v-for="item in regTypeList"
                                   :key="item.value"
                                   :label="item.text"
                                   :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="注册用户::">
                      <el-input v-model="CCBPayReg.fLinkman"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="联系电话::">
                      <el-input v-model="CCBPayReg.fLinkPhone"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="有效起始时间::">
                      <el-date-picker v-model="CCBPayReg.fStartDate"
                                      type="date"
                                      :disabled="!curRowInfo.isEdit"
                                      placeholder="选择有效起始时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="有效结束时间::">
                      <el-date-picker v-model="CCBPayReg.fEndDate"
                                      type="date"
                                      :disabled="!curRowInfo.isEdit"
                                      placeholder="选择有效结束时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="备注::">
                      <el-input v-model="CCBPayReg.fRemark"
                                style="width:500px"
                                :disabled="!curRowInfo.isEdit"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
            <fieldset>
              <legend>建行支付</legend>
              <el-form :model="CCBInfoObject"
                       :inline="true"
                       label-width="120px">
                <el-row class="fRemark_row">
                  <el-col :span="24">
                    <el-form-item label="C2B公钥::">
                      <el-input type="textarea"
                                v-model="CCBInfoObject.p79040"
                                :disabled="!curRowInfo.isEdit"
                                class="parkTextArea"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row class="fRemark_row">
                  <el-col :span="24">
                    <el-form-item label="无感公钥::">
                      <el-input type="textarea"
                                v-model="CCBInfoObject.p79050"
                                :disabled="!curRowInfo.isEdit"
                                class="parkTextArea"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="商户号::">
                      <el-input v-model="CCBInfoObject.p79010"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="分行号::">
                      <el-input v-model="CCBInfoObject.p79030"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="C2B柜台号::">
                      <el-input v-model="CCBInfoObject.p79020"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="无感柜台号::">
                      <el-input v-model="CCBInfoObject.p79055"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="商户类型::">
                      <el-select v-model="CCBInfoObject.p79060"
                                 :disabled="!curRowInfo.isEdit"
                                 placeholder="请选择商户类型"
                                 class="myParkInput">
                        <el-option v-for="item in merchantType"
                                   :key="item.value"
                                   :label="item.label"
                                   :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="启用状态::">
                      <el-radio-group v-model="CCBInfoObject.p79070"
                                      :disabled="!curRowInfo.isEdit"
                                      @change="changeEnable($event,9)">
                        <el-radio label="0">禁用</el-radio>
                        <el-radio label="1">启用</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="无感启用状态::">
                      <el-radio-group v-model="CCBInfoObject.p79080"
                                      :disabled="!curRowInfo.isEdit">
                        <el-radio label="0">禁用</el-radio>
                        <el-radio label="1">启用</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
          </el-tab-pane>
          <el-tab-pane name="CQETCPay"
                       v-if="false">
            <span slot="label"><i class="el-icon-check"
                 v-if="(CQETCInfoObject.p78150=='1')"></i>特微ETC</span>
            <fieldset>
              <legend style="padding-top: 10px">
                注册信息
              </legend>
              <el-form :inline="true"
                       label-width="120px">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="注册方式::">
                      <el-select v-model="CQETCPayReg.fRegType"
                                 placeholder="请选择方式"
                                 :disabled="!curRowInfo.isEdit"
                                 class="myParkInput">
                        <el-option v-for="item in regTypeList"
                                   :key="item.value"
                                   :label="item.text"
                                   :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="注册用户::">
                      <el-input v-model="CQETCPayReg.fLinkman"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="联系电话::">
                      <el-input v-model="CQETCPayReg.fLinkPhone"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="有效起始时间::">
                      <el-date-picker v-model="CQETCPayReg.fStartDate"
                                      type="date"
                                      :disabled="!curRowInfo.isEdit"
                                      placeholder="选择有效起始时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="有效结束时间::">
                      <el-date-picker v-model="CQETCPayReg.fEndDate"
                                      type="date"
                                      :disabled="!curRowInfo.isEdit"
                                      placeholder="选择有效结束时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="备注::">
                      <el-input v-model="CQETCPayReg.fRemark"
                                style="width:500px"
                                :disabled="!curRowInfo.isEdit"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
            <fieldset>
              <legend>特微ETC结算</legend>
              <el-form :model="CQETCInfoObject"
                       :inline="true"
                       label-width="120px">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="省域编码::">
                      <el-input v-model="CQETCInfoObject.p78110"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="停车场业主编码::">
                      <el-input v-model="CQETCInfoObject.p78120"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="停车场编号::">
                      <el-input v-model="CQETCInfoObject.p78130"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="清分结算URL::">
                      <el-input v-model="CQETCInfoObject.p78140"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="签名密钥::">
                      <el-input v-model="CQETCInfoObject.p78141"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="启用状态::">
                      <el-radio-group v-model="CQETCInfoObject.p78150"
                                      :disabled="!curRowInfo.isEdit">
                        <el-radio label="0">禁用</el-radio>
                        <el-radio label="1">启用</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
          </el-tab-pane>
          <el-tab-pane name="QTETCInfo"
                       v-if="false">
            <span slot="label"><i class="el-icon-check"
                 v-if="(QTETCInfoObject.p78240=='1')"></i>黔通ETC</span>
            <fieldset>
              <legend style="padding-top: 10px">
                注册信息
              </legend>
              <el-form :inline="true"
                       label-width="120px">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="注册方式::">
                      <el-select v-model="QTETCPayReg.fRegType"
                                 placeholder="请选择方式"
                                 :disabled="!curRowInfo.isEdit"
                                 class="myParkInput">
                        <el-option v-for="item in regTypeList"
                                   :key="item.value"
                                   :label="item.text"
                                   :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="注册用户::">
                      <el-input v-model="QTETCPayReg.fLinkman"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="联系电话::">
                      <el-input v-model="QTETCPayReg.fLinkPhone"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="有效起始时间::">
                      <el-date-picker v-model="QTETCPayReg.fStartDate"
                                      type="date"
                                      :disabled="!curRowInfo.isEdit"
                                      placeholder="选择有效起始时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="有效结束时间::">
                      <el-date-picker v-model="QTETCPayReg.fEndDate"
                                      type="date"
                                      :disabled="!curRowInfo.isEdit"
                                      placeholder="选择有效结束时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="备注::">
                      <el-input v-model="QTETCPayReg.fRemark"
                                style="width:500px"
                                :disabled="!curRowInfo.isEdit"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
            <fieldset>
              <legend>黔通ETC数据上传</legend>
              <el-form :model="QTETCInfoObject"
                       :inline="true"
                       label-width="120px">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="URL地址::">
                      <el-input v-model="QTETCInfoObject.p78210"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="接入码::">
                      <el-input v-model="QTETCInfoObject.p78220"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="签名码::">
                      <el-input v-model="QTETCInfoObject.p78230"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="启用状态::">
                      <el-radio-group v-model="QTETCInfoObject.p78240"
                                      :disabled="!curRowInfo.isEdit">
                        <el-radio label="0">禁用</el-radio>
                        <el-radio label="1">启用</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
          </el-tab-pane>
          <el-tab-pane name="LZETCPay">
            <span slot="label"><i class="el-icon-check"
                 v-if="(SHETCInfoObject.p78640=='1')"></i>上海公交卡</span>
            <fieldset>
              <legend style="padding-top: 10px">
                注册信息
              </legend>
              <el-form :inline="true"
                       label-width="120px">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="注册方式::">
                      <el-select v-model="SHETCPayReg.fRegType"
                                 placeholder="请选择方式"
                                 :disabled="!curRowInfo.isEdit"
                                 class="myParkInput">
                        <el-option v-for="item in regTypeList"
                                   :key="item.value"
                                   :label="item.text"
                                   :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="注册用户::">
                      <el-input v-model="SHETCPayReg.fLinkman"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="联系电话::">
                      <el-input v-model="SHETCPayReg.fLinkPhone"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="有效起始时间::">
                      <el-date-picker v-model="SHETCPayReg.fStartDate"
                                      type="date"
                                      :disabled="!curRowInfo.isEdit"
                                      placeholder="选择有效起始时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="有效结束时间::">
                      <el-date-picker v-model="SHETCPayReg.fEndDate"
                                      type="date"
                                      :disabled="!curRowInfo.isEdit"
                                      placeholder="选择有效结束时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="备注::">
                      <el-input v-model="SHETCPayReg.fRemark"
                                style="width:500px"
                                :disabled="!curRowInfo.isEdit"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
            <fieldset>
              <legend>联尊ETC数据上传</legend>
              <el-form :model="SHETCInfoObject"
                       :inline="true"
                       label-width="120px">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="停车场服务商::">
                      <el-input v-model="SHETCInfoObject.p78620"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="停车场库编号::">
                      <el-input v-model="SHETCInfoObject.p78630"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="交易上送URL::">
                      <el-input v-model="SHETCInfoObject.p78650"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="交易的文字描述::">
                      <el-input v-model="SHETCInfoObject.p78610"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="启用状态::">
                      <el-radio-group v-model="SHETCInfoObject.p78640"
                                      :disabled="!curRowInfo.isEdit">
                        <el-radio label="0">禁用</el-radio>
                        <el-radio label="1">启用</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
          </el-tab-pane>
          <el-tab-pane name="NYCRMInfo"
                       v-if="false">
            <span slot="label"><i class="el-icon-check"
                 v-if="(NYCRMInfo.p93330=='1')"></i> 诺亚CRM</span>
            <fieldset>
              <legend style="padding-top: 10px">
                诺亚CRM
              </legend>
              <el-form :model="NYCRMInfo"
                       :inline="true"
                       label-width="120px">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="CRM注册码::">
                      <el-input v-model="NYCRMInfo.p93320"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="启用状态::">
                      <el-radio-group v-model="NYCRMInfo.p93330"
                                      :disabled="!curRowInfo.isEdit">
                        <el-radio label="0">禁用</el-radio>
                        <el-radio label="1">启用</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="接口地址::">
                      <el-input v-model="NYCRMInfo.p93310"
                                :disabled="!curRowInfo.isEdit"
                                style="width:500px"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
          </el-tab-pane>
          <el-tab-pane name="JGDTInfo"
                       v-if="false">
            <span slot="label"><i class="el-icon-check"
                 v-if="(JGDTInfo.p93353=='1')"></i> 建工大唐</span>
            <fieldset>
              <legend style="padding-top: 10px">
                建工大唐积分抵扣
              </legend>
              <el-form :model="JGDTInfo"
                       :inline="true"
                       label-width="120px">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="APPKey::">
                      <el-input v-model="JGDTInfo.p93354"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="APPSecret::">
                      <el-input v-model="JGDTInfo.p93355"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="获取优惠券地址::">
                      <el-input v-model="JGDTInfo.p93351"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="核销优惠券地址::">
                      <el-input v-model="JGDTInfo.p93352"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="启用状态::">
                      <el-radio-group v-model="JGDTInfo.p93353"
                                      :disabled="!curRowInfo.isEdit">
                        <el-radio label="0">禁用</el-radio>
                        <el-radio label="1">启用</el-radio>
                      </el-radio-group>
                    </el-form-item>

                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
          </el-tab-pane>
          <el-tab-pane name="NBYSInfo"
                       v-if="false">
            <span slot="label"><i class="el-icon-check"
                 v-if="(NBYSInfo.p93640=='1')"></i> 一咻设置</span>
            <fieldset>
              <legend style="padding-top: 10px">
                一咻设置
              </legend>
              <el-form :model="NBYSInfo"
                       :inline="true"
                       label-width="120px">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="请求方::">
                      <el-input v-model="NBYSInfo.p93610"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="启用状态::">
                      <el-radio-group v-model="NBYSInfo.p93640"
                                      :disabled="!curRowInfo.isEdit">
                        <el-radio label="0">禁用</el-radio>
                        <el-radio label="1">启用</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="接口地址::">
                      <el-input v-model="NBYSInfo.p93630"
                                :disabled="!curRowInfo.isEdit"
                                style="width:500px"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="Key::">
                      <el-input v-model="NBYSInfo.p93620"
                                :disabled="!curRowInfo.isEdit"
                                style="width:500px"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
          </el-tab-pane>
          <el-tab-pane name="YunZongInfo">
            <span slot="label"><i class="el-icon-check"
                 v-if="(YunZongInfoObject.p78490=='1')"></i>云纵电子支付</span>
            <fieldset>
              <legend style="padding-top: 10px">
                注册信息
              </legend>
              <el-form :inline="true"
                       label-width="120px">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="注册方式::">
                      <el-select v-model="YunZongPayReg.fRegType"
                                 placeholder="请选择方式"
                                 :disabled="!curRowInfo.isEdit"
                                 class="myParkInput">
                        <el-option v-for="item in regTypeList"
                                   :key="item.value"
                                   :label="item.text"
                                   :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="注册用户::">
                      <el-input v-model="YunZongPayReg.fLinkman"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="联系电话::">
                      <el-input v-model="YunZongPayReg.fLinkPhone"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="有效起始时间::">
                      <el-date-picker v-model="YunZongPayReg.fStartDate"
                                      type="date"
                                      :disabled="!curRowInfo.isEdit"
                                      placeholder="选择有效起始时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="有效结束时间::">
                      <el-date-picker v-model="YunZongPayReg.fEndDate"
                                      type="date"
                                      :disabled="!curRowInfo.isEdit"
                                      placeholder="选择有效结束时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="备注::">
                      <el-input v-model="YunZongPayReg.fRemark"
                                style="width:500px"
                                :disabled="!curRowInfo.isEdit"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
            <fieldset>
              <legend style="color:red">云纵电子支付参数</legend>
              <el-form :model="YunZongInfoObject"
                       :inline="true"
                       label-width="120px">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="机构号::">
                      <el-input v-model="YunZongInfoObject.p78410"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="商户号::">
                      <el-input v-model="YunZongInfoObject.p78420"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="停车场ID::">
                      <el-input v-model="YunZongInfoObject.p78430"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="支付地址::">
                      <el-select v-model="YunZongInfoObject.p78440"
                                 :disabled="!curRowInfo.isEdit"
                                 class="myParkInput"
                                 placeholder="请选择版本">
                        <el-option v-for="item in yzUrlList"
                                   :key="item.value"
                                   :label="item.label"
                                   :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="支付版本号::">
                      <el-select v-model="YunZongInfoObject.p78450"
                                 :disabled="!curRowInfo.isEdit"
                                 class="myParkInput"
                                 placeholder="请选择版本">
                        <el-option v-for="item in yzVerList"
                                   :key="item.value"
                                   :label="item.label"
                                   :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row class="fRemark_row">
                  <el-col :span="24">
                    <el-form-item label="云纵公钥::">
                      <el-input type="textarea"
                                v-model="YunZongInfoObject.p78460"
                                :disabled="!curRowInfo.isEdit"
                                class="parkTextArea"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row class="fRemark_row">
                  <el-col :span="24">
                    <el-form-item label="软杰私钥::">
                      <el-input type="textarea"
                                v-model="YunZongInfoObject.p78470"
                                :disabled="!curRowInfo.isEdit"
                                class="parkTextArea"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row class="fRemark_row">
                  <el-col :span="24">
                    <el-form-item label="软杰公钥::">
                      <el-input type="textarea"
                                v-model="YunZongInfoObject.p78480"
                                :disabled="!curRowInfo.isEdit"
                                class="parkTextArea"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="启用状态::">
                      <el-radio-group v-model="YunZongInfoObject.p78490"
                                      :disabled="!curRowInfo.isEdit">
                        <el-radio label="0">禁用</el-radio>
                        <el-radio label="1">启用</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
          </el-tab-pane>
          <el-tab-pane name="YunZongADInfo">
            <span slot="label"><i class="el-icon-check"
                 v-if="(YunZongADInfoObject.p78590=='1')"></i>云纵广告</span>
            <fieldset>
              <legend style="padding-top: 10px">
                注册信息
              </legend>
              <el-form :inline="true"
                       label-width="120px">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="注册方式::">
                      <el-select v-model="YunZongADPayReg.fRegType"
                                 placeholder="请选择方式"
                                 :disabled="!curRowInfo.isEdit"
                                 class="myParkInput">
                        <el-option v-for="item in regTypeList"
                                   :key="item.value"
                                   :label="item.text"
                                   :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="注册用户::">
                      <el-input v-model="YunZongADPayReg.fLinkman"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="联系电话::">
                      <el-input v-model="YunZongADPayReg.fLinkPhone"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="有效起始时间::">
                      <el-date-picker v-model="YunZongADPayReg.fStartDate"
                                      type="date"
                                      :disabled="!curRowInfo.isEdit"
                                      placeholder="选择有效起始时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="有效结束时间::">
                      <el-date-picker v-model="YunZongADPayReg.fEndDate"
                                      type="date"
                                      :disabled="!curRowInfo.isEdit"
                                      placeholder="选择有效结束时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="备注::">
                      <el-input v-model="YunZongADPayReg.fRemark"
                                style="width:500px"
                                :disabled="!curRowInfo.isEdit"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
            <fieldset>
              <legend style="color:red">云纵广告参数</legend>
              <el-form :model="YunZongADInfoObject"
                       :inline="true"
                       label-width="140px">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="Banner广告::">
                      <el-input v-model="YunZongADInfoObject.p78510"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="直跳广告::">
                      <el-input v-model="YunZongADInfoObject.p78520"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <legend style="color:red">Banner广告请求参数(服务端请求时以下两个参数必填)</legend>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="客户端IP::">
                      <el-input v-model="YunZongADInfoObject.p78530"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="客户端User-Agent::">
                      <el-input v-model="YunZongADInfoObject.p78540"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="启用状态::">
                      <el-radio-group v-model="YunZongADInfoObject.p78590"
                                      :disabled="!curRowInfo.isEdit">
                        <el-radio label="0">禁用</el-radio>
                        <el-radio label="1">启用</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
          </el-tab-pane>
          <el-tab-pane name="AntSmartEtcInfo">
            <span slot="label"><i class="el-icon-check"
                 v-if="(AntSmartEtcObject.p79306=='1')"></i>蚂蚁智行</span>
            <fieldset>
              <legend style="padding-top: 10px">
                注册信息
              </legend>
              <el-form :inline="true"
                       label-width="120px">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="注册方式::">
                      <el-select v-model="AntSmartEtcReg.fRegType"
                                 placeholder="请选择方式"
                                 :disabled="!curRowInfo.isEdit"
                                 class="myParkInput">
                        <el-option v-for="item in regTypeList"
                                   :key="item.value"
                                   :label="item.text"
                                   :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="注册用户::">
                      <el-input v-model="AntSmartEtcReg.fLinkman"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="联系电话::">
                      <el-input v-model="AntSmartEtcReg.fLinkPhone"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="有效起始时间::">
                      <el-date-picker v-model="AntSmartEtcReg.fStartDate"
                                      type="date"
                                      :disabled="!curRowInfo.isEdit"
                                      placeholder="选择有效起始时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="有效结束时间::">
                      <el-date-picker v-model="AntSmartEtcReg.fEndDate"
                                      type="date"
                                      :disabled="!curRowInfo.isEdit"
                                      placeholder="选择有效结束时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="备注::">
                      <el-input v-model="AntSmartEtcReg.fRemark"
                                style="width:500px"
                                :disabled="!curRowInfo.isEdit"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
            <fieldset>
              <legend style="color:red">蚂蚁智行参数</legend>
              <el-form :model="AntSmartEtcObject"
                       :inline="true"
                       label-width="140px">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="服务商编码::">
                      <el-input v-model="AntSmartEtcObject.p79305"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="授权码::">
                      <el-input v-model="AntSmartEtcObject.p79304"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="公钥::">
                      <el-input v-model="AntSmartEtcObject.p79302"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="私钥::">
                      <el-input v-model="AntSmartEtcObject.p79303"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="启用状态::">
                      <el-radio-group v-model="AntSmartEtcObject.p79306"
                                      :disabled="!curRowInfo.isEdit">
                        <el-radio label="0">禁用</el-radio>
                        <el-radio label="1">启用</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="支付URL::">
                      <el-input v-model="AntSmartEtcObject.p79301"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
          </el-tab-pane>
          <el-tab-pane name="AHSRCBPayInfo">
            <span slot="label"><i class="el-icon-check"
                 v-if="(AHSRCBPayInfoObject.p79405=='1'||AHSRCBPayInfoObject.p79405=='1')"></i> 安徽农商支付</span>
            <fieldset>
              <legend style="padding-top: 10px">
                注册信息
              </legend>
              <el-form label-width="120px"
                       :inline="true">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="注册方式::">
                      <el-select v-model="AHSRCBPayReg.fRegType"
                                 placeholder="请选择方式"
                                 :disabled="!curRowInfo.isEdit"
                                 class="myParkInput">
                        <el-option v-for="item in regTypeList"
                                   :key="item.value"
                                   :label="item.text"
                                   :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="注册用户::">
                      <el-input v-model="AHSRCBPayReg.fLinkman"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="联系电话::">
                      <el-input v-model="AHSRCBPayReg.fLinkPhone"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="有效起始时间::">
                      <el-date-picker v-model="AHSRCBPayReg.fStartDate"
                                      type="date"
                                      :disabled="!curRowInfo.isEdit"
                                      placeholder="选择有效起始时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="有效结束时间::">
                      <el-date-picker v-model="AHSRCBPayReg.fEndDate"
                                      :disabled="!curRowInfo.isEdit"
                                      type="date"
                                      placeholder="选择有效结束时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="备注::">
                      <el-input v-model="AHSRCBPayReg.fRemark"
                                style="width:500px"
                                :disabled="!curRowInfo.isEdit"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
            <fieldset>
              <legend>安徽农商支付</legend>
              <el-form :inline="true"
                       label-width="120px">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="商户号::">
                      <el-input v-model="AHSRCBPayInfoObject.p79401"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="终端号::">
                      <el-input v-model="AHSRCBPayInfoObject.p79402"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="支付链接::">
                      <el-input v-model="AHSRCBPayInfoObject.p79403"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="APPKEY::">
                      <el-input v-model="AHSRCBPayInfoObject.p79404"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="启用状态::">
                      <el-radio-group v-model="AHSRCBPayInfoObject.p79405"
                                      :disabled="!curRowInfo.isEdit"
                                      @change="changeEnable($event,10)">
                        <el-radio label="0">禁用</el-radio>
                        <el-radio label="1">启用</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="回调接口::">
                      <el-input v-model="AHSRCBPayInfoObject.p79406"
                                :disabled="!curRowInfo.isEdit"
                                class="myParkInput"></el-input>(一定要用19080端口)
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
          </el-tab-pane>
        </el-tabs>
        <el-row style="margin-top:-1px">
          <el-col :span="12">
            <div class="tab_foot">&nbsp;</div>
          </el-col>
          <el-col :span="12">
            <div class="dialog-footer">
              <el-button type="primary"
                         @click="submitForm('form')"
                         v-if="curRowInfo.isEdit"
                         :loading="save_loading">{{save_msg}}</el-button>
              <el-button @click="editOrDetailVisible = false">取消</el-button>
            </div>
          </el-col>
        </el-row>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import $ from 'jquery'
export default {
  name: 'roadSideParkMain',
  data () {
    return {
      is_admin: false,
      parkPicSaveList: [],
      autoDelDataList: [],
      autoDelDataDefaultValue: '',
      parkPicSaveDefaultValue: '',
      businessTimeList: [],
      save_msg: '保存',
      save_loading: false,
      loading: false,
      AntSmartEtcReg: {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      },
      AntSmartEtcObject: {
        p79301: '',
        p79302: '',
        p79303: '',
        p79304: '',
        p79305: '',
        p79306: '0'
      },
      BOCMWxPayReg: {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      },
      BOCMWxInfoObject: {
        p75010: '',
        p75020: '',
        p75030: '',
        p75040: '',
        p75050: '',
        p75060: '',
        p75070: '',
        p75080: '0',
        p75090: '',
        p75100: '',
        p75110: ''
      },
      AHSRCBPayInfoObject: {
        p79401: '',
        p79402: '',
        p79403: 'https://epos.ahrcu.com:3443',
        p79404: '',
        p79405: '0',
        p79406: 'http://ansrcbpay.shangjieiot.com:19080'
      },
      AHSRCBPayReg: {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      },
      alipayInfoObject: {
        p74010: '',
        p74030: '',
        p74020: '',
        p74040: '',
        p74060: '0',
        p74001: '',
        p74002: ''

      },
      aliPayReg: {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      },
      ICBCPayReg: {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      },
      ICBCInfoObject: {
        p76010: '',
        p76020: '',
        p76030: '',
        p76040: '',
        p76050: '',
        p76060: '',
        p76070: '',
        p76080: '',
        p76090: ''
      },
      wechatComInfoObject: {
        p73010: '',
        p73020: '',
        p73030: '',
        p73040: '',
        p73080: '',
        p73090: '',
        p73070: '',
        p73050: '0'
      },
      weChatSvrPayReg: {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      },
      wechatSerInfoObject: {
        p72010: '',
        p72020: '',
        p72030: '',
        p72040: '',
        p72050: '',
        p72060: '',
        p72100: '',
        p72110: '',
        p72080: '',
        p72070: '0'
      },
      weChatComPayReg: {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      },
      unionPayInfoObject: {
        p71010: '',
        p71020: '',
        p71030: '',
        p71040: '',
        p71050: '',
        p71060: '0',
        p71110: '',
        p71120: '',
        p71130: '',
        p71140: '',
        p71150: '',
        p71160: '',
        p71210: '',
        p71190: '0',
        p71991: '',
        p71992: '',
        p71990: '',
        p71993: ''

      },
      unionPayReg: {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      },
      RJInvoiceObject: {
        p99110: '',
        p99120: '',
        p99130: '',
        p99140: '',
        p99150: '',
        p99160: '0'
      },
      EInvoiceObject: {
        p99210: '',
        p99220: '',
        p99230: '',
        p99240: '',
        p99250: '',
        p99260: '',
        p99270: '',
        p99280: '',
        p99290: '',
        p99299: ''
      },
      HTInvoiceObject: {
        p99801: '',
        p99802: '',
        p99803: '',
        p99804: '',
        p99805: '',
        p99806: '',
        p99807: '30',
        p99808: '0'
      },
      CGBPayReg: {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      },
      CGBInfoObject: {
        p77010: '',
        p77020: '',
        p77030: '',
        p77040: '',
        p77050: ''
      },
      CCBPayReg: {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      },
      CCBInfoObject: {
        p79010: '',
        p79020: '',
        p79030: '',
        p79040: '',
        p79050: '',
        p79055: '',
        p79060: '',
        p79070: '',
        p79080: ''
      },
      CQETCPayReg: {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      },
      CQETCInfoObject: {
        p78110: '',
        p78120: '',
        p78130: '',
        p78140: '',
        p78141: '',
        p78150: ''
      },
      QTETCPayReg: {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      },
      QTETCInfoObject: {
        p78210: '',
        p78220: '',
        p78230: '',
        p78240: ''
      },
      SHETCPayReg: {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      },
      SHETCInfoObject: {
        p78610: '',
        p78620: '',
        p78630: '',
        p78640: '',
        p78650: ''
      },
      NYCRMInfo: {
        p93310: '',
        p93320: '',
        p93330: ''
      },
      JGDTInfo: {
        p93351: '',
        p93352: '',
        p93353: '',
        p93354: '',
        p93355: ''
      },
      NBYSInfo: {
        p93610: '',
        p93620: '',
        p93630: '',
        p93640: ''
      },
      YunZongPayReg: {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      },
      YunZongInfoObject: {
        p78410: '',
        p78420: '',
        p78430: '',
        p78440: '',
        p78450: '',
        p78460: '',
        p78470: '',
        p78480: '',
        p78490: ''
      },
      YunZongADPayReg: {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      },
      YunZongADInfoObject: {
        p78510: '',
        p78520: '',
        p78530: '',
        p78540: '',
        p78590: ''
      },
      AppletPayReg: {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      },
      AppletInfoObject: {
        p73110: '',
        p73130: '',
        p73115: '',
        p73150: '',
        p73151: '',
        p73152: '',
        p73153: '',
        p73165: ''
      },
      parkSetting: {
        p10010: '0',
        p10020: '0',
        p10021: '0',
        p10022: '0',
        p10023: '0',
        p10024: '0',
        p10030: '',
        p10170: '',
        p10140: '',
        p10100: '',
        p10040: false,
        p10050: 0,
        p10060: false,
        p10070: 0,
        p10080: false,
        p10190: false,
        p10090: false,
        p10091: false,
        p10110: '',
        p10150: '',
        p10160: '',
        p10180: '',
        p10230: '',
        p10105: '',
        p10250: '',
        p10260: '',
        p10270: '',
        p10280: '',
        p10290: false,
        p10106: '',
        p10210: false,
        p10240: false,
        p10220: '',
        p10200: '',
        p10112: '',
        p10111: '',
        p10320: '',
        p10330: '',
        p10350: ''
      },
      curRowInfo: {
        fBigRowID: '',
        op: '',
        fCompanyID: 0,
        isEdit: false,
        fParkID: '',
        fCustID: '',
        fCustNo: '',
        fParkNo: '',
        fParkName: '',
        fParkTypeID: '',
        fLinkman: '',
        fLinkPhone: '',
        fAddress: '',
        fParkCount: '',
        fResCount: '',
        fMapSvrID: '1',
        fLongitude: '',
        fLatitude: '',
        fHigh: '0',
        fProvinceID: 0,
        fCityID: 0,
        fDistID: 0,
        fProvName: '',
        fCityName: '',
        fDistName: '',
        fIsDel: '',
        fIsSyncData: ''
      },
      regTypeList: [{ text: '公司代理', value: '0' }, { text: '用户注册', value: '1' }],
      merchantType: [{ label: '线上POS档案商户', value: '1' }, { label: '线下POS档案商户', value: '2' }],
      rateSelectList: [{ text: '无', value: '' }],
      c2bUrlList: [{ label: 'V2（默认）', value: 'https://gw.open.icbc.com.cn/api/qrcode/V2/generate' }, { label: 'V1（南京）', value: 'https://gw.open.icbc.com.cn/api/cardbusiness/qrcode/qrgenerate/V1' }],
      b2cUrlList: [{ label: 'V4（默认）', value: 'https://gw.open.icbc.com.cn/api/qrcode/pay/V4' }, { label: 'V2（成都）', value: 'https://gw.open.icbc.com.cn/api/qrcode/V2/pay' }],
      platePayUrlList: [{ label: 'V1（默认）', value: 'https://gw.open.icbc.com.cn/api/b2c/licenseplate/payment/pay/V1' }, { label: 'V3（成都）', value: 'https://gw.open.icbc.com.cn/api/b2c/licenseplate/payment/pay/V3' }],
      yzUrlList: [{ label: 'V2（默认）', value: 'https://po.yunzongnet.com/api/v2/gateway' }],
      yzVerList: [{ label: '2.0（默认）', value: '2.0' }],
      plateUrlList: [{ label: 'V3（成都）', value: 'https://gw.open.icbc.com.cn/ui/b2c/ui/licenseplate/payment/agreement/V3' }],
      tab_height: 0,
      detailTitle: '',
      editOrDetail: 'editBaseInfo',
      IPAddr: '',
      IPPort: '',
      map: undefined,
      map_search_list: [],
      editOrDetailVisible: false,
      is_edit: true,
      is_del: true,
      queryParkName: '',
      queryParkNo: '',
      selCustID: '',
      choiceCusts: [],
      parkList: [],
      tableHeight: 0,
      pageSize: 20,
      pageIndex: 1,
      total: 0
    }
  },
  methods: {
    ...mapActions([
      'getParkByCurrUser', 'getCustByGroup', 'getRateGroupByCustId', 'getMapAndParkType', 'deleteRoadSidePark',
      'saveRoadSidePark', 'getRoadSideParkParams', 'getCurrentUserPers'
    ]),
    updatePark (row, isEdit, op) {
      this.setDefault()
      let curRow = {}
      Object.assign(curRow, row)
      this.curRowInfo = curRow
      this.curRowInfo.isEdit = isEdit
      this.curRowInfo.op = op
      this.detailTitle = '【' + row.fCustName + '(' + row.fCustNo + ')' + '-' + row.fParkName + '】' + (isEdit ? '编辑场库' : '查看场库')
      this.rateSelectList = [{ text: '无', value: '0' }]
      this.map_search_list = []
      this.$nextTick(() => {
        this.createBaiduMap()
      })
      this.editOrDetailVisible = true
      setTimeout(() => {
        this.setTabHeight()
      }, 100)
      this.getRoadSideParkParams({ fCustID: row.fCustID, fParkID: row.fParkID, fIsSyn: false }).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              let tmprateSelectList = []
              Object.assign(tmprateSelectList, data.Data.rateSelectList)
              // var parkSetting = (data.Data.parkSetting || {})
              // if (parkSetting.p10010 && parkSetting.p10010 === '0') {
              //   parkSetting.p10010 = ''
              // }
              // if (parkSetting.p10020 && parkSetting.p10020 === '0') {
              //   parkSetting.p10020 = ''
              // }
              // if (parkSetting.p10021 && parkSetting.p10021 === '0') {
              //   parkSetting.p10021 = ''
              // }
              // if (parkSetting.p10022 && parkSetting.p10022 === '0') {
              //   parkSetting.p10022 = ''
              // }
              // if (parkSetting.p10023 && parkSetting.p10023 === '0') {
              //   parkSetting.p10023 = ''
              // }
              // if (parkSetting.p10024 && parkSetting.p10024 === '0') {
              //   parkSetting.p10024 = ''
              // }
              Object.assign(this.parkSetting, data.Data.parkSetting)
              tmprateSelectList.forEach((value, index) => {
                this.rateSelectList.push(value)
              })
              Object.assign(this.unionPayInfoObject, data.Data.unionPayInfoObject)
              // this.unionPay = data.Data.unionPayExist

              Object.assign(this.wechatSerInfoObject, data.Data.wechatSerInfoObject)
              // this.wechatSer = data.Data.wechatSerExist // this.wechatSerInfoObject && this.wechatSerInfoObject.length > 0

              Object.assign(this.wechatComInfoObject, data.Data.wechatComInfoObject)
              // this.wechatCom = data.Data.wechatComExist // this.wechatComInfoObject && this.wechatComInfoObject.length > 0

              Object.assign(this.alipayInfoObject, data.Data.alipayInfoObject)
              // this.alipay = data.Data.alipayExist// this.alipayInfoObject && this.alipayInfoObject.length > 0
              Object.assign(this.ICBCInfoObject, data.Data.ICBCInfoObject)
              Object.assign(this.CGBInfoObject, data.Data.CGBInfoObject)

              Object.assign(this.BOCMWxInfoObject, data.Data.BOCMWxInfoObject)
              Object.assign(this.RJInvoiceObject, data.Data.RJInvoiceObject)
              Object.assign(this.EInvoiceObject, data.Data.EInvoiceObject)
              Object.assign(this.unionPayReg, data.Data.unionPayReg)
              Object.assign(this.aliPayReg, data.Data.aliPayReg)
              Object.assign(this.weChatComPayReg, data.Data.weChatComPayReg)
              Object.assign(this.weChatSvrPayReg, data.Data.weChatSvrPayReg)
              Object.assign(this.BOCMWxPayReg, data.Data.BOCMWxPayReg)
              Object.assign(this.ICBCPayReg, data.Data.ICBCPayReg)
              Object.assign(this.CGBPayReg, data.Data.CGBPayReg)
              Object.assign(this.CCBPayReg, data.Data.CCBPayReg)
              Object.assign(this.CCBInfoObject, data.Data.CCBInfoObject)
              Object.assign(this.CQETCPayReg, data.Data.CQETCPayReg)
              Object.assign(this.CQETCInfoObject, data.Data.CQETCInfoObject)
              Object.assign(this.SHETCPayReg, data.Data.SHETCPayReg)
              Object.assign(this.SHETCInfoObject, data.Data.SHETCInfoObject)
              Object.assign(this.NYCRMInfo, data.Data.NYCRMInfo)
              Object.assign(this.JGDTInfo, data.Data.JGDTInfo)
              Object.assign(this.NBYSInfo, data.Data.NBYSInfo)
              Object.assign(this.YunZongInfoObject, data.Data.YunZongInfoObject)
              Object.assign(this.YunZongADInfoObject, data.Data.YunZongADInfoObject)
              Object.assign(this.QTETCPayReg, data.Data.QTETCPayReg)
              Object.assign(this.QTETCInfoObject, data.Data.QTETCInfoObject)
              Object.assign(this.YunZongPayReg, data.Data.YunZongPayReg)
              Object.assign(this.YunZongADPayReg, data.Data.YunZongADPayReg)
              Object.assign(this.AppletPayReg, data.Data.AppletPayReg)
              Object.assign(this.AppletInfoObject, data.Data.AppletInfoObject)
              Object.assign(this.AntSmartEtcReg, data.Data.AntSmartEtcReg)
              Object.assign(this.AntSmartEtcObject, data.Data.AntSmartEtcObject)
              Object.assign(this.AHSRCBPayReg, data.Data.AHSRCBPayReg)
              Object.assign(this.AHSRCBPayInfoObject, data.Data.AHSRCBPayInfoObject)
              Object.assign(this.HTInvoiceObject, data.Data.HTInvoiceObject)
              // this.unionPayStatus = data.Data.unionPayStatus
              // this.wechatSerStatus = data.Data.wechatSerStatus
              // this.wechatComStatus = data.Data.wechatComStatus
              // this.alipayStatus = data.Data.alipayStatus
            } else {
              this.$message.error(data.Msg)
            }
          }
        }
      })
    },
    viewRoadSidePark (row) {
      this.editOrDetail = 'editBaseInfo'
      if (row && row !== null && typeof (row) !== 'undefined') {
        this.updatePark(row, false, 'view')
      }
    },
    editParkClient (index, row) {
      this.editOrDetail = 'editBaseInfo'
      if (row && row !== null && typeof (row) !== 'undefined') {
        this.updatePark(row, true, 'edit')
      }
    },
    addRoadSidePark () {
      this.setDefault()
      this.editOrDetailVisible = true
      this.curRowInfo.isEdit = true
      this.curRowInfo.op = 'add'
      this.detailTitle = '新增停车场'
      this.editOrDetail = 'editBaseInfo'
      setTimeout(() => {
        this.setTabHeight()
      }, 100)

      this.map_search_list = []
      this.$nextTick(() => {
        this.createBaiduMap()
      })
      this.curRowInfo.fParkTypeID = this.parkTypeDefaultValue
      this.curRowInfo.fResCount = 0
      this.parkSetting.p10030 = 0
      this.parkSetting.p10170 = this.parkPicSaveDefaultValue
      this.parkSetting.p10105 = this.parkFullTmpMgrDefaultValue
      this.parkSetting.p10106 = this.parkFullMonMgrDefaultValue
      this.parkSetting.p10350 = this.autoDelDataDefaultValue
      this.parkSetting.p10010 = '0'
      this.parkSetting.p10020 = '0'
      this.parkSetting.p10021 = '0'
      this.parkSetting.p10022 = '0'
      this.parkSetting.p10023 = '0'
      this.parkSetting.p10024 = '0'
      this.parkSetting.p10320 = '00:00'
      this.parkSetting.p10330 = '24:00'
      this.parkSetting.p10270 = ''
      this.parkSetting.p10280 = ''
      this.parkSetting.p10290 = false
      this.parkSetting.p10040 = true
      this.parkSetting.p10060 = true
      this.parkSetting.p10080 = true
      this.parkSetting.p10190 = true
      this.parkSetting.p10050 = 0
      this.parkSetting.p10070 = 0
      this.parkSetting.p10180 = 15
      this.parkSetting.p10090 = true
      this.parkSetting.p10091 = true
      this.parkSetting.p10240 = true
      this.map_search_list = []
      this.$nextTick(() => {
        this.createBaiduMap()
      })
    },
    deleteParkClient (index, row) {
      this.$confirm('删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteRoadSidePark({ fParkID: row.fParkID, fCustID: row.fCustID, fCustNo: row.fCustNo, fBigRowID: row.fBigRowID, fIsSyn: false, fIsPay: false }).then(res => {
          if (res && res.data) {
            let { status, data } = res
            if (status === 200) {
              if (data.IsOk) {
                this.$message({
                  type: 'success',
                  message: data.Msg
                })
                this.initData()
              } else {
                this.$message.error(data.Msg)
              }
            }
          }
        })
      })
    },
    submitForm (formName) {
      if ((this.curRowInfo.fCustID || '').trim().length <= 0) {
        this.$message.error('请先选择客户')
        return false
      }
      let tmpCust = this.choiceCusts.filter(item => {
        if (item.fCustID === this.curRowInfo.fCustID) { return item }
      })
      if ((tmpCust || []).length <= 0) {
        this.$message.error('选择的客户不存在')
        return false
      }
      this.curRowInfo.fCustNo = tmpCust[0].fCustNo
      this.curRowInfo.fParkTypeID = 310
      let param = {}
      param.curRowInfo = this.curRowInfo
      param.curRowInfo.fIsDel = 0
      param.parkSetting = this.parkSetting
      param.curRowInfo = this.curRowInfo
      param.unionPayInfoObject = this.unionPayInfoObject
      param.wechatSerInfoObject = this.wechatSerInfoObject
      param.wechatComInfoObject = this.wechatComInfoObject
      param.alipayInfoObject = this.alipayInfoObject
      param.BOCMWxInfoObject = this.BOCMWxInfoObject
      param.RJInvoiceObject = this.RJInvoiceObject
      param.EInvoiceObject = this.EInvoiceObject
      param.ICBCInfoObject = this.ICBCInfoObject
      param.CGBInfoObject = this.CGBInfoObject
      param.CCBInfoObject = this.CCBInfoObject
      param.CQETCInfoObject = this.CQETCInfoObject
      param.SHETCInfoObject = this.SHETCInfoObject
      param.unionPayReg = this.unionPayReg
      param.nYCRMInfo = this.NYCRMInfo
      param.JGDTInfo = this.JGDTInfo
      param.nBYSInfo = this.NBYSInfo
      param.AHSRCBPayInfoObject = this.AHSRCBPayInfoObject
      param.YunZongInfoObject = this.YunZongInfoObject
      param.YunZongADInfoObject = this.YunZongADInfoObject
      param.QTETCInfoObject = this.QTETCInfoObject
      param.AppletInfoObject = this.AppletInfoObject
      param.AntSmartEtcReg = this.AntSmartEtcReg
      param.AntSmartEtcObject = this.AntSmartEtcObject
      param.HTInvoiceObject = this.HTInvoiceObject
      if (param.AntSmartEtcReg.fStartDate instanceof Date) {
        param.AntSmartEtcReg.fStartDate = this.$dateFormat(param.AntSmartEtcReg.fStartDate, 'yyyy-MM-dd')
      }
      if (param.AntSmartEtcReg.fEndDate instanceof Date) {
        param.AntSmartEtcReg.fEndDate = this.$dateFormat(param.AntSmartEtcReg.fEndDate, 'yyyy-MM-dd')
      }
      if (param.unionPayReg.fStartDate instanceof Date) {
        param.unionPayReg.fStartDate = this.$dateFormat(param.unionPayReg.fStartDate, 'yyyy-MM-dd')
      }
      if (param.unionPayReg.fEndDate instanceof Date) {
        param.unionPayReg.fEndDate = this.$dateFormat(param.unionPayReg.fEndDate, 'yyyy-MM-dd')
      }
      param.aliPayReg = this.aliPayReg
      if (param.aliPayReg.fStartDate instanceof Date) {
        param.aliPayReg.fStartDate = this.$dateFormat(param.aliPayReg.fStartDate, 'yyyy-MM-dd')
      }
      if (param.aliPayReg.fEndDate instanceof Date) {
        param.aliPayReg.fEndDate = this.$dateFormat(param.aliPayReg.fEndDate, 'yyyy-MM-dd')
      }
      param.weChatComPayReg = this.weChatComPayReg
      if (param.weChatComPayReg.fStartDate instanceof Date) {
        param.weChatComPayReg.fStartDate = this.$dateFormat(param.weChatComPayReg.fStartDate, 'yyyy-MM-dd')
      }
      if (param.weChatComPayReg.fEndDate instanceof Date) {
        param.weChatComPayReg.fEndDate = this.$dateFormat(param.weChatComPayReg.fEndDate, 'yyyy-MM-dd')
      }
      param.weChatSvrPayReg = this.weChatSvrPayReg
      if (param.weChatSvrPayReg.fStartDate instanceof Date) {
        param.weChatSvrPayReg.fStartDate = this.$dateFormat(param.weChatSvrPayReg.fStartDate, 'yyyy-MM-dd')
      }
      if (param.weChatSvrPayReg.fEndDate instanceof Date) {
        param.weChatSvrPayReg.fEndDate = this.$dateFormat(param.weChatSvrPayReg.fEndDate, 'yyyy-MM-dd')
      }
      param.BOCMWxPayReg = this.BOCMWxPayReg
      if (param.BOCMWxPayReg.fStartDate instanceof Date) {
        param.BOCMWxPayReg.fStartDate = this.$dateFormat(param.BOCMWxPayReg.fStartDate, 'yyyy-MM-dd')
      }
      if (param.BOCMWxPayReg.fEndDate instanceof Date) {
        param.BOCMWxPayReg.fEndDate = this.$dateFormat(param.BOCMWxPayReg.fEndDate, 'yyyy-MM-dd')
      }
      param.ICBCPayReg = this.ICBCPayReg
      if (param.ICBCPayReg.fStartDate instanceof Date) {
        param.ICBCPayReg.fStartDate = this.$dateFormat(param.ICBCPayReg.fStartDate, 'yyyy-MM-dd')
      }
      if (param.ICBCPayReg.fEndDate instanceof Date) {
        param.ICBCPayReg.fEndDate = this.$dateFormat(param.ICBCPayReg.fEndDate, 'yyyy-MM-dd')
      }
      param.CGBPayReg = this.CGBPayReg
      if (param.CGBPayReg.fStartDate instanceof Date) {
        param.CGBPayReg.fStartDate = this.$dateFormat(param.CGBPayReg.fStartDate, 'yyyy-MM-dd')
      }
      if (param.CGBPayReg.fEndDate instanceof Date) {
        param.CGBPayReg.fEndDate = this.$dateFormat(param.CGBPayReg.fEndDate, 'yyyy-MM-dd')
      }
      param.CCBPayReg = this.CCBPayReg
      if (param.CCBPayReg.fStartDate instanceof Date) {
        param.CCBPayReg.fStartDate = this.$dateFormat(param.CCBPayReg.fStartDate, 'yyyy-MM-dd')
      }
      if (param.CCBPayReg.fEndDate instanceof Date) {
        param.CCBPayReg.fEndDate = this.$dateFormat(param.CCBPayReg.fEndDate, 'yyyy-MM-dd')
      }
      param.CQETCPayReg = this.CQETCPayReg
      if (param.CQETCPayReg.fStartDate instanceof Date) {
        param.CQETCPayReg.fStartDate = this.$dateFormat(param.CQETCPayReg.fStartDate, 'yyyy-MM-dd')
      }
      if (param.CQETCPayReg.fEndDate instanceof Date) {
        param.CQETCPayReg.fEndDate = this.$dateFormat(param.CQETCPayReg.fEndDate, 'yyyy-MM-dd')
      }
      param.SHETCPayReg = this.SHETCPayReg
      if (param.SHETCPayReg.fStartDate instanceof Date) {
        param.SHETCPayReg.fStartDate = this.$dateFormat(param.SHETCPayReg.fStartDate, 'yyyy-MM-dd')
      }
      if (param.SHETCPayReg.fEndDate instanceof Date) {
        param.SHETCPayReg.fEndDate = this.$dateFormat(param.SHETCPayReg.fEndDate, 'yyyy-MM-dd')
      }
      param.YunZongPayReg = this.YunZongPayReg
      if (param.YunZongPayReg.fStartDate instanceof Date) {
        param.YunZongPayReg.fStartDate = this.$dateFormat(param.YunZongPayReg.fStartDate, 'yyyy-MM-dd')
      }
      if (param.YunZongPayReg.fEndDate instanceof Date) {
        param.YunZongPayReg.fEndDate = this.$dateFormat(param.YunZongPayReg.fEndDate, 'yyyy-MM-dd')
      }
      param.YunZongADPayReg = this.YunZongADPayReg
      if (param.YunZongADPayReg.fStartDate instanceof Date) {
        param.YunZongADPayReg.fStartDate = this.$dateFormat(param.YunZongADPayReg.fStartDate, 'yyyy-MM-dd')
      }
      if (param.YunZongADPayReg.fEndDate instanceof Date) {
        param.YunZongADPayReg.fEndDate = this.$dateFormat(param.YunZongADPayReg.fEndDate, 'yyyy-MM-dd')
      }
      param.QTETCPayReg = this.QTETCPayReg
      if (param.QTETCPayReg.fStartDate instanceof Date) {
        param.QTETCPayReg.fStartDate = this.$dateFormat(param.QTETCPayReg.fStartDate, 'yyyy-MM-dd')
      }
      if (param.QTETCPayReg.fEndDate instanceof Date) {
        param.QTETCPayReg.fEndDate = this.$dateFormat(param.QTETCPayReg.fEndDate, 'yyyy-MM-dd')
      }
      param.AppletPayReg = this.AppletPayReg
      if (param.AppletPayReg.fStartDate instanceof Date) {
        param.AppletPayReg.fStartDate = this.$dateFormat(param.AppletPayReg.fStartDate, 'yyyy-MM-dd')
      }
      if (param.AppletPayReg.fEndDate instanceof Date) {
        param.AppletPayReg.fEndDate = this.$dateFormat(param.AppletPayReg.fEndDate, 'yyyy-MM-dd')
      }
      param.AHSRCBPayReg = this.AHSRCBPayReg
      if (param.AHSRCBPayReg.fStartDate instanceof Date) {
        param.AHSRCBPayReg.fStartDate = this.$dateFormat(param.AHSRCBPayReg.fStartDate, 'yyyy-MM-dd')
      }
      if (param.AHSRCBPayReg.fEndDate instanceof Date) {
        param.AHSRCBPayReg.fEndDate = this.$dateFormat(param.AHSRCBPayReg.fEndDate, 'yyyy-MM-dd')
      }
      this.save_loading = true
      this.save_msg = '保存中...'
      this.saveRoadSidePark(param).then(res => {
        this.save_loading = false
        this.save_msg = '保存'
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.initData()
              this.editOrDetailVisible = false
              this.$message({
                type: 'success',
                message: data.Msg
              })
            } else {
              this.$message.error(data.Msg)
            }
          }
        }
      })
    },
    changeInvoiceEnable (val, type) {
      if (val) {
        switch (type) {
          case 1: // 容津
            this.EInvoiceObject.p99299 = '0'
            this.HTInvoiceObject.p99808 = '0'
            break
          case 2:
            this.RJInvoiceObject.p99160 = '0'
            this.HTInvoiceObject.p99808 = '0'
            break
          case 3:
            this.EInvoiceObject.p99299 = '0'
            this.RJInvoiceObject.p99160 = '0'
            break
        }
      }
    },
    changeEnable (val, type, typeName) {
      if (val === '1') {
        switch (type) {
          case 1: // 银联
            this.wechatComInfoObject.p73050 = '0'
            this.wechatSerInfoObject.p72070 = '0'
            this.alipayInfoObject.p74060 = '0'
            this.BOCMWxInfoObject.p75080 = '0'
            this.ICBCInfoObject.p76090 = '0'
            this.CGBInfoObject.p77050 = '0'
            this.CCBInfoObject.p79070 = '0'
            this.CCBInfoObject.p79080 = '0'
            this.AHSRCBPayInfoObject.p79405 = '0'
            if (typeName === 'b2c') {
              this.unionPayInfoObject.p71030 = '46938143680ffdf301682b1cd4a70006'
              this.unionPayInfoObject.p71040 = '67440d9cb2984c31874b2acb2d6556fa'
              this.unionPayInfoObject.p71050 = 'https://qr.chinaums.com/netpay-route-server/api/'
            } else {
              this.unionPayInfoObject.p71130 = 'QRPAYDEFAULT'
              this.unionPayInfoObject.p71140 = 'WWW.SHRUANJIE.COM'
              this.unionPayInfoObject.p71150 = '5135'
              this.unionPayInfoObject.p71160 = 'mTejiB5hacQrTTz5dzsE5ziDHRWFsDG47kDssyswDWfB5dX8'
              this.unionPayInfoObject.p71210 = 'https://qr.chinaums.com/netpay-route-server/api/'
            }

            break
          case 2: // 微信商户
            this.unionPayInfoObject.p71060 = '0'
            this.unionPayInfoObject.p71190 = '0'
            this.wechatComInfoObject.p73050 = '0'
            this.BOCMWxInfoObject.p75080 = '0'
            this.ICBCInfoObject.p76090 = '0'
            this.CGBInfoObject.p77050 = '0'
            this.CCBInfoObject.p79070 = '0'
            this.CCBInfoObject.p79080 = '0'
            this.AHSRCBPayInfoObject.p79405 = '0'
            break
          case 3: // 微信普通商户
            this.unionPayInfoObject.p71060 = '0'
            this.unionPayInfoObject.p71190 = '0'
            this.wechatSerInfoObject.p72070 = '0'
            this.BOCMWxInfoObject.p75080 = '0'
            this.ICBCInfoObject.p76090 = '0'
            this.CGBInfoObject.p77050 = '0'
            this.CCBInfoObject.p79070 = '0'
            this.CCBInfoObject.p79080 = '0'
            this.AHSRCBPayInfoObject.p79405 = '0'
            break
          case 4: // 支付宝
            this.unionPayInfoObject.p71060 = '0'
            this.unionPayInfoObject.p71190 = '0'
            this.BOCMWxInfoObject.p75080 = '0'
            this.ICBCInfoObject.p76090 = '0'
            this.CGBInfoObject.p77050 = '0'
            this.CCBInfoObject.p79070 = '0'
            this.CCBInfoObject.p79080 = '0'
            this.AHSRCBPayInfoObject.p79405 = '0'
            break
          case 5: // 交行支付
            this.unionPayInfoObject.p71060 = '0'
            this.unionPayInfoObject.p71190 = '0'
            this.wechatComInfoObject.p73050 = '0'
            this.wechatSerInfoObject.p72070 = '0'
            this.alipayInfoObject.p74060 = '0'
            this.ICBCInfoObject.p76090 = '0'
            this.CGBInfoObject.p77050 = '0'
            this.CCBInfoObject.p79070 = '0'
            this.CCBInfoObject.p79080 = '0'
            this.AHSRCBPayInfoObject.p79405 = '0'
            break
          case 6: // 工行支付
            this.unionPayInfoObject.p71060 = '0'
            this.unionPayInfoObject.p71190 = '0'
            this.wechatComInfoObject.p73050 = '0'
            this.wechatSerInfoObject.p72070 = '0'
            this.BOCMWxInfoObject.p75080 = '0'
            this.alipayInfoObject.p74060 = '0'
            this.CGBInfoObject.p77050 = '0'
            this.CCBInfoObject.p79070 = '0'
            this.CCBInfoObject.p79080 = '0'
            this.AHSRCBPayInfoObject.p79405 = '0'
            break
          case 7: // 广发支付
            this.unionPayInfoObject.p71060 = '0'
            this.unionPayInfoObject.p71190 = '0'
            this.wechatComInfoObject.p73050 = '0'
            this.wechatSerInfoObject.p72070 = '0'
            this.BOCMWxInfoObject.p75080 = '0'
            this.alipayInfoObject.p74060 = '0'
            this.ICBCInfoObject.p76090 = '0'
            this.CCBInfoObject.p79070 = '0'
            this.CCBInfoObject.p79080 = '0'
            this.AHSRCBPayInfoObject.p79405 = '0'
            break
          case 8:
            if ((this.AppletInfoObject.p73110 || '').trim().length <= 0) {
              this.AppletInfoObject.p73110 = '20191223'
            }
            if ((this.AppletInfoObject.p73130 || '').trim().length <= 0) {
              this.AppletInfoObject.p73130 = '83d96c2aec5deaa8e2d675d9121cef4e11'
            }
            if ((this.AppletInfoObject.p73150 || '').trim().length <= 0) {
              this.AppletInfoObject.p73150 = 'https://fpj.datarj.com/einv/kptService/rj/rjxx'
            }
            if ((this.AppletInfoObject.p73151 || '').trim().length <= 0) {
              this.AppletInfoObject.p73151 = 'https://wxpap.shangjieiot.com/api.php'
            }
            break
          case 9: // 建行支付
            this.unionPayInfoObject.p71060 = '0'
            this.unionPayInfoObject.p71190 = '0'
            this.wechatComInfoObject.p73050 = '0'
            this.wechatSerInfoObject.p72070 = '0'
            this.BOCMWxInfoObject.p75080 = '0'
            this.alipayInfoObject.p74060 = '0'
            this.ICBCInfoObject.p76090 = '0'
            this.CGBInfoObject.p77050 = '0'
            this.AHSRCBPayInfoObject.p79405 = '0'
            break
          case 10: // 建行支付
            this.unionPayInfoObject.p71060 = '0'
            this.unionPayInfoObject.p71190 = '0'
            this.wechatComInfoObject.p73050 = '0'
            this.wechatSerInfoObject.p72070 = '0'
            this.BOCMWxInfoObject.p75080 = '0'
            this.alipayInfoObject.p74060 = '0'
            this.ICBCInfoObject.p76090 = '0'
            this.CGBInfoObject.p77050 = '0'
            this.CCBInfoObject.p79070 = '0'
            break
        }
      }
    },
    setParams (result, type) {
      switch (type) {
        case 1:
          if (result) {
            // 上传数据地址
            this.RJInvoiceObject.p99140 = 'http://open2.datarj.com/webService/kptService'
            // 开票链接
            this.RJInvoiceObject.p99150 = 'https://fpj.datarj.com/einv/kptService/rj/rjxx'
          } else {
            // 上传数据地址
            this.RJInvoiceObject.p99140 = ''
            // 开票链接
            this.RJInvoiceObject.p99150 = ''
          }
          break
        case 2:
          if (result) {
            // 公众账号ID
            this.wechatSerInfoObject.p72010 = 'wx2ec887417aa7ba68'
            // 商户号
            this.wechatSerInfoObject.p72020 = '1543527411'
            // AppKey
            this.wechatSerInfoObject.p72050 = 'RUANjie1122334455Sh1122334455jie'
            // 密钥
            this.wechatSerInfoObject.p72060 = '04bec2e9a8b9229d7e936a336583c012'
            // 进场通知
            this.wechatSerInfoObject.p72100 = 'BF5wu72eJwW6ZmlbR9-y66m_PlBTnoBbHDHwJ56iSpQ'
            // 出场通知
            this.wechatSerInfoObject.p72110 = 'IDTUs0njchqwFh9GdmE-r9xWqhkmGhppUQcH-r9FQpM'
          } else {
            // 公众账号ID
            this.wechatSerInfoObject.p72010 = ''
            // 商户号
            this.wechatSerInfoObject.p72020 = ''
            // AppKey
            this.wechatSerInfoObject.p72050 = ''
            // 密钥
            this.wechatSerInfoObject.p72060 = ''
            // 进场通知
            this.wechatSerInfoObject.p72100 = ''
            // 出场通知
            this.wechatSerInfoObject.p72110 = ''
          }
          break
        case 3:
          if (result) {
            // 支付宝AppID
            this.alipayInfoObject.p74010 = '2019080666158161'
            // 商户私钥
            this.alipayInfoObject.p74030 = 'MIIEogIBAAKCAQEAh8SOFObquBPEKgw8Sgpar5578/g7K3A6sirBUyhpLDfxSFCEj4eEdftekP5y2rX6rsMFvhCQk6MiGJhMId7YIdclTrlGFOsIVELwZdgQ0P8KQGKmNGj2cnEVYYr5cWUR8Nr/0mSxupzEbm4yFi1rVkhH1GTBC9a9XIIGbQgWMIPOkWAiq/DFLGW/m5x5FPr/xLEZo6S3GtSUiE0SUfS6uSVd8wuvYoyZwIzuizT+8TiVEPafbypvUPVpV4QW09q00U6DovjpBwwTCt1eOjOL7ujCWlqlpqgXkvCr8RfYBE2b0Xbw+El/Omd+8xM1cBlyii2o5jBQYygggz2+zBhepwIDAQABAoIBAEspm+cid+t0tfL5Vx8+YDo9qS3FzSwdM8GTPfgFtUQPrHp2aQz033ZZtV7cH0XJ3YCG41T34rJ5a9Tl67AMqOcDLtpIY+4MuE29yUz4s0ahC1Hdy1nUiiuNQ2L/B12psKcA9wPJT0OaqnzgcMYqWvQni+yf4ufk+GyQZ3JROcedPIXSxPAnBOIwkK8RL/FE2eJrqk4Ma7iDgqlXB7KyWeSXFbmziAhhh8ergecf5cBMCJDlM5uulQd3OD1/2Eae+dy9ERZpdtL5SRaHvDDft4AjXaX3/6LY7bBvbcAh9JDIdJKRRD5o/82BoD1oy7x5mHzheVJZGasDtt/5GyWFJ8ECgYEA7QaecLY5aeGm8SVwNiFT59dVK7KyRbthzKlRtxRofG06I6hTSCMBJHgD66+h1Wl95gCqQgUjvgeqYYyRcMBoedeFT/cEIUrx6T8RPxOzIlQcsTAvD4JVKU5u+1IrA8uhLgRAz+vVlbpHVnMEdbdIfCyMuyyLtryPzmnfTMC0vjcCgYEAkqLZqmAXI670zkRCwzWpW3iIG6ak2CfeLSw7O4/Gt847u4ygitan3SMICI3rcFAhd5zA5UZzAj6jE0ZMJYeFIvlJFUdg2lS0hDJiKoUmON0sIHPOuGYqQdAws6Ey/MJPyk+BdzPmeB+phemI/YWqh4sYw3neiurX7D5Byna/qxECgYBGPyLv5qGnZrASYfUapc/3MxNT6xb4oas/e6LzLoI09i436SgdhfpNs5/91sSQuj4Mz3+mJ13LcPwnAwELuIp+KcihxWSc9Vgyt3VGC3GYp/ME9HHOF+NjZZJwu45yBoSTXcFTneJkCJwh296jgJlj69QdmPsjQkkgdLIwTiCDCwKBgCWZtqDWlPhkc4e0vz3ZM70t0hDtEVYQGwuQTPv/6R/WtUBpVf1j/5VX10aCRb39/ibyvg/Mmc8Yiq51ly8EaiJGs/PN4sr5b3R6iuuGSv/HzvnfWEG2iN1paiOVkUJ4/QbOjk8nstBYphqdgLApp0msZEQzqtoKUCXW7P3ip1FRAoGALlf7vTQuLKIoibtzqOe2LUCwKbNx2qSIAwTPFzzo9vdaLC/29ruvtk2mNtoYJjKTf0VojOIaw9Rrort1Xrim/LaPF7sk/3Q12JFlqlER5Wla4GJ9Ec1XfKSK3CNAZJznL2w2u4T7YqLbXXwIVh9wQlXMz25tvYSmo9ryxRDtblM='
            // 支付宝公钥
            this.alipayInfoObject.p74020 = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAiBoXDptcd7R9oZ6OLJv89+gVPCRrnTJ5ImihRh0AxVgROmgCkV2obN2kvnr8DYQJcUApm9IIBqCfkWMjiTf0vPkOJ8qYLF9B+iaAnwUeIGdpsZBJS7TgfW+U0era0K3dLlLhorjBhu9SonmIoYXQ2l4IF+sXHduzUkgI572dNL/D5/CENZeFLfJ1EkpEBuFjj7XX2Wa7K3UNfdTKynO+ELfdwqw7stUTSmHScWtGbGT0tvIvL1G5XZtO4DFsBPHG+p+s/ytfDt2aDvF9qaC0+/rmF13AYJdzAGkcIfVHqYOktnUATJp/6KSSRknRbUxovXil14aAcnuxHdWkcILHpQIDAQAB'
            // 服务商PID
            this.alipayInfoObject.p74001 = '2088531665011033'
            // 支付链接
            this.alipayInfoObject.p74040 = 'https://openapi.alipay.com/gateway.do'
          } else {
            // 支付宝AppID
            this.alipayInfoObject.p74010 = ''
            // 商户私钥
            this.alipayInfoObject.p74030 = ''
            // 支付宝公钥
            this.alipayInfoObject.p74020 = ''
            // 服务商PID
            this.alipayInfoObject.p74001 = ''
            // 支付链接
            this.alipayInfoObject.p74040 = ''
          }
          break
      }
    },
    address_keyup (e) {
      if ((this.curRowInfo.fAddress || '').trim().length <= 0) {
        this.map_search_list = []
        this.curRowInfo.fAddress = ''
        this.curRowInfo.fLongitude = ''
        this.curRowInfo.fLatitude = ''
        this.curRowInfo.fProvName = ''
        this.curRowInfo.fCityName = ''
        this.curRowInfo.fDistName = ''
        return false
      }
      $(this.$el).find('.search_list .el-row').removeClass('selected')
      var options = {
        onSearchComplete: (results) => {
          if (local.getStatus() === 0) {
            this.map_search_list = []
            for (var i = 0; i < results.getCurrentNumPois(); i++) {
              if (i < 6) {
                this.map_search_list.push(results.getPoi(i))
              }
            }
          }
        }
      }
      var local = new window.BMapGL.LocalSearch(this.map, options)
      local.search(this.curRowInfo.fAddress.trim())
      // var geo = new window.BMap.Geocoder()
      // geo.getPoint(this.curRowInfo.fAddress.trim(), (point) => {
      //   if (point) {
      //     geo.getLocation(point, (rs) => {
      //       var addComp = rs.addressComponents
      //       this.map.clearOverlays()
      //       var mk = new window.BMap.Marker(point)
      //       this.map.addOverlay(mk)
      //       this.map.panTo(point)
      //       this.curRowInfo.fAddress = addComp.province + addComp.city + addComp.district + addComp.street + addComp.streetNumber
      //       this.curRowInfo.fLongitude = point.lng
      //       this.curRowInfo.fLatitude = point.lat
      //       this.curRowInfo.fProvName = addComp.province
      //       this.curRowInfo.fCityName = addComp.city
      //       this.curRowInfo.fDistName = addComp.district
      //     })
      //   }
      // })
    },
    map_search_change (address, index) {
      $(this.$el).find('.search_list .el-row').removeClass('selected')
      $(this.$el).find('.search_list .el-row:eq(' + index + ')').addClass('selected')
      this.curRowInfo.fAddress = address.address || ''
      this.curRowInfo.fLongitude = address.point.lng
      this.curRowInfo.fLatitude = address.point.lat
      this.curRowInfo.fProvName = address.province || ''
      this.curRowInfo.fCityName = address.city || ''
      this.curRowInfo.fDistName = address.title
      this.map.clearOverlays()
      var mk = new window.BMapGL.Marker(address.point)
      this.map.addOverlay(mk)
      this.map.panTo(address.point)
    },
    custChange (selValue) {
      let param = {}
      param.fCustID = selValue
      this.parkSetting.p10010 = '0'
      this.parkSetting.p10020 = '0'
      this.parkSetting.p10021 = '0'
      this.parkSetting.p10022 = '0'
      this.parkSetting.p10024 = '0'
      this.parkSetting.p10023 = '0'
      this.rateSelectList = [{ text: '无', value: '0' }]
      this.getRateGroupByCustId(param).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              let tmprateSelectList = []
              Object.assign(tmprateSelectList, data.Data)
              tmprateSelectList.forEach((value, index) => {
                this.rateSelectList.push(value)
              })
            }
          }
        }
      })
    },
    bindQuery () {
      this.initData()
    },
    tab_click (tab) {
      this.setTabHeight($('#' + tab.$el.id).height())
    },
    setTabHeight (contentHeight) {
      var height = $('.roadSideParkEditOrDetail .el-tabs__content:eq(0)').height()
      if (this.tab_height <= 0) {
        this.tab_height = $('.roadSideParkEditOrDetail .el-tabs__nav-scroll:eq(0)').height()
      }
      if (contentHeight) {
        $('.roadSideParkEditOrDetail .el-tabs__nav-scroll:eq(0)').css('height', (this.tab_height > contentHeight ? this.tab_height : contentHeight) + 'px')
      } else {
        $('.roadSideParkEditOrDetail .el-tabs__nav-scroll:eq(0)').css('height', (height > this.tab_height ? height : this.tab_height) + 'px')
      }
    },
    indexMethod (index) {
      return this.pageSize * (this.pageIndex - 1) + index + 1
    },
    setDefault () {
      for (let key in this.curRowInfo) {
        this.curRowInfo[key] = ''
      }
      this.curRowInfo.fProvinceID = 0
      this.curRowInfo.fCityID = 0
      this.curRowInfo.fDistID = 0
      this.curRowInfo.isEdit = false
      this.curRowInfo.fMapSvrID = '1'
      this.curRowInfo.fCompanyID = 0
      for (let key in this.parkSetting) {
        this.parkSetting[key] = ''
      }
      this.rateSelectList = [{ text: '无', value: '' }]
      this.parkSetting.p10050 = 0
      this.parkSetting.p10070 = 0

      for (let key in this.alipayInfoObject) {
        this.alipayInfoObject[key] = ''
      }
      for (let key in this.wechatComInfoObject) {
        this.wechatComInfoObject[key] = ''
      }
      for (let key in this.wechatSerInfoObject) {
        this.wechatSerInfoObject[key] = ''
      }
      for (let key in this.unionPayInfoObject) {
        this.unionPayInfoObject[key] = ''
      }
      for (let key in this.BOCMWxInfoObject) {
        this.BOCMWxInfoObject[key] = ''
      }
      for (let key in this.RJInvoiceObject) {
        this.RJInvoiceObject[key] = ''
      }
      for (let key in this.EInvoiceObject) {
        this.EInvoiceObject[key] = ''
      }
      for (let key in this.ICBCInfoObject) {
        this.ICBCInfoObject[key] = ''
      }
      for (let key in this.CGBInfoObject) {
        this.CGBInfoObject[key] = ''
      }
      for (let key in this.CCBInfoObject) {
        this.CCBInfoObject[key] = ''
      }
      for (let key in this.CQETCInfoObject) {
        this.CQETCInfoObject[key] = ''
      }
      for (let key in this.YunZongInfoObject) {
        this.YunZongInfoObject[key] = ''
      }
      for (let key in this.YunZongADInfoObject) {
        this.YunZongADInfoObject[key] = ''
      }
      for (let key in this.QTETCInfoObject) {
        this.QTETCInfoObject[key] = ''
      }
      for (let key in this.AppletInfoObject) {
        this.AppletInfoObject[key] = ''
      }
      this.CGBPayReg = {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      }
      this.unionPayReg = {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      }
      this.aliPayReg = {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      }
      this.weChatComPayReg = {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      }
      this.weChatSvrPayReg = {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      }
      this.BOCMWxPayReg = {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      }
      this.ICBCPayReg = {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      }
      this.CCBPayReg = {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      }
      this.CQETCPayReg = {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      }
      this.SHETCPayReg = {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      }
      this.NYCRMInfo = {
        p93310: '',
        p93320: '',
        p93330: '0'
      }
      this.JGDTInfo = {
        p93351: '',
        p93352: '',
        p93353: '0',
        p93354: '',
        p93355: ''
      }
      this.NBYSInfo = {
        p93610: '',
        p93620: '',
        p93630: '',
        p93640: '0'
      }
      this.YunZongPayReg = {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      }
      this.YunZongADPayReg = {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      }
      this.QTETCPayReg = {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      }
      this.AppletPayReg = {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      }
      this.AHSRCBPayInfoObject = {
        p79401: '',
        p79402: '',
        p79403: 'https://epos.ahrcu.com:3443',
        p79404: '',
        p79405: '0',
        p79406: 'http://ansrcbpay.shangjieiot.com:19080'
      }
      this.AHSRCBPayReg = {
        fRegType: '0',
        fLinkman: '',
        fLinkPhone: '',
        fStartDate: '',
        fEndDate: '',
        fRemark: ''
      }
      this.HTInvoiceObject = this.$options.data().HTInvoiceObject
      // this.isEdit = false
      this.unionPayInfoObject.p71060 = '0'
      this.unionPayInfoObject.p71190 = '0'
      this.wechatSerInfoObject.p72070 = '0'
      this.wechatComInfoObject.p73050 = '0'
      this.alipayInfoObject.p74060 = '0'
      this.BOCMWxInfoObject.p75080 = '0'
      this.RJInvoiceObject.p99160 = '0'
      this.EInvoiceObject.p99299 = '0'
      this.ICBCInfoObject.p76090 = '0'
      this.ICBCInfoObject.p76091 = '0'
      this.CGBInfoObject.p77050 = '0'
      this.CCBInfoObject.p79070 = '0'
      this.CCBInfoObject.p79080 = '0'
      this.CQETCInfoObject.p78150 = '0'
      this.QTETCInfoObject.p78240 = '0'
      this.SHETCInfoObject.p78640 = '0'
      this.YunZongInfoObject.p78490 = '0'
      this.YunZongADInfoObject.p78590 = '0'
      this.AppletInfoObject.p73152 = '0'
      this.AppletInfoObject.p73165 = '0'
      this.AntSmartEtcObject.p79306 = '0'
      this.AntSmartEtcObject.p79403 = 'https://epos.ahrcu.com:3443'
      this.AntSmartEtcObject.p79406 = 'http://ansrcbpay.shangjieiot.com:19080'
    },
    handleSizeChange (value) {
      this.pageSize = value
      this.initData()
    },
    handlePage (index) {
      this.pageIndex = index
      this.initData()
    },
    initData () {
      let param = {}
      param['fCustID'] = this.selCustID
      param['fParkName'] = this.queryParkName.trim()
      param['fParkNo'] = this.queryParkNo.trim()
      param['isRoadPark'] = true
      param.pageSize = this.pageSize
      param.pageIndex = this.pageIndex
      param.parkActiveName = ''
      this.parkList = []
      this.loading = true
      this.getParkByCurrUser(param).then(res => {
        this.loading = false
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              let tmpParks = []
              Object.assign(tmpParks, data.Data.data)
              this.parkList = data.Data.data || []
              this.total = data.Data.count
            }
          }
        }
      })
    },
    createBaiduMap () {
      this.map = new window.BMapGL.Map('parkBaiduMap')// 显示标签
      var point = new window.BMapGL.Point(116.331398, 39.897445)
      this.map.centerAndZoom(point, 16)
      this.map.enableScrollWheelZoom(true)
      var geoc = new window.BMapGL.Geocoder()
      this.map.addControl(new window.BMapGL.NavigationControl())
      this.map.enableAutoResize()
      if (this.curRowInfo.fLongitude > 0 && this.curRowInfo.fLatitude > 0) {
        this.map.clearOverlays()
        var newPoint = new window.BMapGL.Point(this.curRowInfo.fLongitude, this.curRowInfo.fLatitude)
        var marker = new window.BMapGL.Marker(newPoint)
        this.map.addOverlay(marker)
        this.map.panTo(newPoint)
      }

      this.map.addEventListener('click', (e) => {
        $(this.$el).find('.search_list .el-row').removeClass('selected')
        this.map_search_list = []
        var pt = new window.BMapGL.Point(e.latlng.lng, e.latlng.lat)
        geoc.getLocation(pt, (rs) => {
          var addComp = rs.addressComponents
          this.map.clearOverlays()
          var mk = new window.BMapGL.Marker(pt)
          this.map.addOverlay(mk)
          this.map.panTo(pt)
          this.curRowInfo.fAddress = rs.address || ''
          this.curRowInfo.fLongitude = pt.lng
          this.curRowInfo.fLatitude = pt.lat
          this.curRowInfo.fProvName = addComp.province
          this.curRowInfo.fCityName = addComp.city
          this.curRowInfo.fDistName = addComp.district
        })
      })
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 25 - 230
      obj.tableHeight = clientHeight
    }
  },
  created () {
    this.getCurrentUserPers({ perTypeId: 80000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_edit = data.Data.data.is_edit
            this.is_del = data.Data.data.is_del
            this.is_admin = data.Data.is_admin
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    window.onresize = () => {
      this.setTableHeight(this)
    }
    this.initData()
    this.getCustByGroup({ fCustTypeID: 1 }).then(res => {
      if (res && res.data) {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            let custs = []
            let all = {}
            all['fCustID'] = ' '
            all['unionName'] = '所有客户'
            Object.assign(custs, data.Data)
            this.choiceCusts = custs
            // if (this.choiceCusts && this.choiceCusts.length > 0) {
            //    this.selCustID = this.choiceCusts[0].fCustID
            // }
            // this.choiceCusts.unshift(all)
          }
        }
      }
    })
    this.getMapAndParkType({}).then(res => {
      if (res && res.data) {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            let parkPicSaveList = []
            let autoDelDataList = []
            Object.assign(parkPicSaveList, data.Data.parkPicSaveList)
            Object.assign(autoDelDataList, data.Data.autoDelDataList)
            this.autoDelDataList = autoDelDataList
            this.parkPicSaveList = parkPicSaveList
            this.parkPicSaveDefaultValue = data.Data.parkPicSaveDefaultValue
            this.IPAddr = data.Data.IPAddr
            this.IPPort = data.Data.IPPort
            this.autoDelDataDefaultValue = data.Data.autoDelDataDefaultValue
          }
        }
      }
    })
    for (var i = 0; i < 24; i++) {
      for (var j = 0; j < 12; j++) {
        var option = (i < 10 ? '0' + i : i) + ':' + ((j * 5) < 10 ? '0' + (j * 5) : (j * 5))
        this.businessTimeList.push({ text: option, value: option })
      }
    }
    this.businessTimeList.push({ text: '24:00', value: '24:00' })
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>

<style>
.roadSideParkEditOrDetail .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
.roadSideParkEditOrDetail .el-dialog__title {
  color: white;
}
.roadSideParkEditOrDetail .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
.roadSideParkEditOrDetail .el-dialog__body {
  padding: 0px;
}
.roadSideParkEditOrDetail .myParkInput {
  width: 220px;
}
.roadSideParkEditOrDetail
  .el-tabs--left.el-tabs--card
  .el-tabs__nav
  > .el-tabs__item {
  text-align: right;
}
.roadSideParkEditOrDetail .fRemark_row .el-form-item__content {
  height: 60px;
}
.roadSideParkEditOrDetail .parkTextArea .el-textarea__inner {
  width: 800px;
  height: 60px;
}
/* .roadSideParkEditOrDetail .myParkInput input.el-input__inner {
    line-height: 30px !important;
    height: 30px !important;
    color: #666666;
    font-size: 13px;
  } */
.roadSideParkEditOrDetail .el-row {
  margin-top: 5px;
}
.roadSideParkEditOrDetail .el-radio {
  line-height: 2px;
}
.roadSideParkEditOrDetail .is-disabled .el-input__inner,
.roadSideParkEditOrDetail .is-disabled .el-textarea__inner {
  color: #606266;
}
/* tab 样式 */
.roadSideParkEditOrDetail .el-tabs__item {
  padding: 0px 20px 0px 0px;
}
.roadSideParkEditOrDetail .el-tabs__nav-scroll {
  background-color: #ccc;
  text-align: center;
  width: 110px;
  overflow: auto;
}
.roadSideParkEditOrDetail .el-tabs__nav-next,
.roadSideParkEditOrDetail .el-tabs__nav-prev {
  display: none;
}
.roadSideParkEditOrDetail .el-tabs__nav-wrap.is-scrollable {
  padding: 0px !important;
}
.roadSideParkEditOrDetail .el-tabs--left.el-tabs--card .el-tabs__item.is-left {
  border: none !important;
}
.roadSideParkEditOrDetail .el-tabs__item:hover {
  color: white;
  background-color: #409eff;
}
.roadSideParkEditOrDetail .el-tabs--left.el-tabs--card .el-tabs__nav {
  border-bottom: none;
}
.roadSideParkEditOrDetail .el-tabs__nav {
  margin-top: -1px;
  margin-left: -1px;
}
.roadSideParkEditOrDetail .el-tabs--left .el-tabs__header.is-left {
  margin-right: 0px;
}
.roadSideParkEditOrDetail .child_card .el-tabs__nav-scroll{
  width: 100%;
}
.roadSideParkEditOrDetail .child_card .el-tabs__item{
 padding: 0px 20px;
 text-align: center !important;
}
#roadSideParkMain .warning-row {
  color: chocolate;
}
#roadSideParkMain .el-dialog {
  min-width: 1100px;
}
</style>
<style scoped>
fieldset {
  padding-bottom: 0px;
}
.search_list .t {
  color: #1eb1fb;
  font-weight: 700;
  min-height: 35px;
  line-height: 35px;
  font-size: 14px;
  padding: 0 7px;
}
#parkBaiduMap {
  float: left;
}
.search_list .a {
  min-height: 20px;
  line-height: 20px;
  font-size: 14px;
  color: #666;
  padding: 0 7px;
}
.search_list {
  height: 300px;
  width: 300px;
  overflow-y: auto;
  float: left;
}
.search_list .el-row {
  margin-top: 0px;
}
.search_list .el-row.selected,
.search_list .el-row:hover {
  background: #dcd9d9;
  cursor: pointer;
}
.parkMain_BaseInfo .el-select {
  width: 100%;
}
.pagination {
  text-align: right;
  padding-top: 5px;
}

.el-form-item {
  margin-bottom: 0px;
}
.dialog-video-wrapper .el-dialog__body {
  padding: 5px;
}
.myel-input__inner {
  height: 20px;
  line-height: 20px;
}
legend {
  display: block;
  width: 100%;
  padding: 0;
  margin-bottom: 10px;
  line-height: inherit;
  color: #333;
  border: 0;
  border-bottom: 1px solid #e5e5e5;
}
fieldset {
  margin: 0 2px;
  border: 0px solid silver;
}
.trans_row {
  padding-top: 20px;
  border-top: 1px solid #e5e5e5;
}
.tab_foot {
  width: 110px;
  height: 80px;
  background: #ccc;
}
.dialog-footer {
  text-align: right;
  padding: 20px;
}
.searchRowAdd {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/view/roadSidePark/roadSideParkMain.vue